<template>
  <div id="carte">

    <!-- Spinner de chargement de la carte -->
    <transition name="fade">
      <div v-if="spinner.is_loading" class="spinner-container">
        <spinner size="big" message="Veuillez patienter..." :font-size="20"></spinner>
      </div>
    </transition>

    <div id="mainMenu" class="sidebar-vertical sidebar-hidden sidebar-vertical-bottom" v-if="user">

      <div id="closeToggleMenu" class="closeToggleMenu" @click="toggleNavbar()">
        <i class="fa fa-chevron-right c-blue"></i>
      </div>

      <!-- SIDE NAV -->
      <div class="">

        <transition name="fade">

          <!-- LISTE DES ZONES -->
          <div class="container" v-if="current_page == 'ZONES'">

            <div class="heading-title heading-border-bottom heading-color">
              <h5>Liste des <span>zones</span></h5>
            </div>

            <table class="table table-striped table-vertical-middle mt-10 fs-14">

              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Armoire</th>
                  <th>Mode</th>
                  <th>Réception en erreur ?</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>

                <tr v-for="(zone, i_zone) in zones" class="c-pointer" @click="centreGoogleMapTo(zone, zone.type)">

                  <td>
                    <div>
                      {{zone.libelle}}
                    </div>
                  </td>

                  <td>
                    <div v-if="!zone.date_ouverture_porte">Fermé</div>
                    <div v-if="zone.date_ouverture_porte">Ouverte depuis le {{zone.date_ouverture_porte}}</div>
                  </td>

                  <td>
                    <div v-for="(voie, i_voie) in zone.voies">
                      Voie {{i_voie+1}} :
                      <b v-if="voie.is_crepusculaire">
                        Mode crépusculaire
                      </b>
                      <b v-else>
                        Mode horaire
                      </b>
                    </div>
                  </td>

                  <td>
                    <div v-if="zone.is_erreur_reception">
                      Oui
                    </div>
                    <div v-else>
                      Non
                    </div>
                  </td>

                  <td>
                    <div>
                      <button @click="setZones(zone)" class="btn btn-sm btn-default">Modifier</button>
                    </div>
                  </td>

                </tr>

              </tbody>

            </table>

          </div>


          <!-- LOG APPLICATIFS -->
          <div class="container" v-if="current_page == 'LOG'">

            <div class="heading-title heading-border-bottom heading-color">
              <h5>Logs <span>applicatifs</span></h5>
            </div>

            <table class="table table-striped table-vertical-middle mt-10 fs-14">

              <thead>
                <tr>
                  <th>Heure serveur</th>
                  <th>Login</th>
                  <th>Description</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>

                <tr v-for="log in logs">
                  <td>{{log.date | moment("DD/MM/YYYY HH:mm:ss")}}</td>
                  <td>{{log.login}}</td>
                  <td>{{log.description}}</td>
                  <td>{{log.action}}</td>
                </tr>

              </tbody>

            </table>

          </div>

          <!-- UTILISATEUR -->
          <div class="container" v-if="current_page == 'UTILISATEUR'">

            <!-- CREATION UTILISATEUR -->
            <div class="" v-if="utilisateur_action == 'add_utilisateur'">

              <div class="heading-title heading-border-bottom heading-color">
                <h5>Création <span>utilisateur</span></h5>
              </div>

              <div class="row mt-10 sky-form">

                <div class="col-xl-6 mb-10">
                  <h6>Login de connexion</h6>
                  <div class="input">
                    <i class="ico-append fa fa-user"></i>
                    <input type="text" maxlength="20" placeholder="Login" v-model="new_user.datas.login"/>
                    <b class="tooltip tooltip-bottom-right">Veuillez renseigner un login permettant de connecter l'utilisateur</b>
                  </div>
                </div>

                <div class="col-xl-6 mb-10">
                  <h6>Mot de passe de connexion</h6>
                  <div class="input">
                    <i class="ico-append fa fa-lock"></i>
                    <input type="password" maxlength="20" placeholder="Mot de passe" v-model="new_user.datas.pass"/>
                    <b class="tooltip tooltip-bottom-right">Veuillez renseigner un mot de passe permettant de connecter l'utilisateur</b>
                  </div>
                </div>

                <div class="col-xl-6 mb-10">
                  <h6>Description</h6>
                  <div class="input">
                    <i class="ico-append fa fa-user"></i>
                    <input type="text" maxlength="200" placeholder="Description" v-model="new_user.datas.description"/>
                  </div>
                </div>

                <div class="col-xl-6 mb-10">
                  <h6>Date de validité du compte utilisateur</h6>
                  <div class="input">
                    <date-picker format="dd/MM/yyyy" lang="fr" width="300" v-model="new_user.datas.date_validite"></date-picker>
                  </div>
                </div>

              </div>

              <div class="heading-title heading-line-single mt-10">
                <h5>Affecter les zones à l'<span>utilisateur</span></h5>
              </div>

              <div class="zones-container">
                <div class="zone sky-form mb-10" v-for="(zone, i_zone) in zones">

                  <div class="row">
                    <div class="col-md-4 col-sm-12">
                      <div><b>{{zone.libelle}}</b></div>
                    </div>
                    <div class="col-md-8">

                      <div class="voie">
                        <label class="switch switch-primary d-inline">
                          <input type="checkbox" @click="toggleCheckedZone(zone, 1, 'zone_' + zone.id_zone + '_voie_1_active', 'new_user')" v-bind:id="'zone_' + zone.id_zone + '_voie_1_active'">
                          <span class="switch-label" data-on="ON" data-off="OFF" ></span>
                          <span class="fs-12">
                            VOIE 1
                          </span>
                        </label>

                        <!-- Ouverture popup -->
                        <span class="choose_date_utilisateur">
                          <a href="javascript:void(0)" v-popover="{name: 'popup_zone_' + i_zone + '_voie_1'}" class="c-pointer pr-10">
                            <i class="fa fa-calendar"></i>
                            <span v-if="!new_user.voie_1.date_limite[i_zone]">Aucune date de limite</span>
                            <span v-else>Limite : {{new_user.voie_1.date_limite[i_zone] | moment("DD/MM/YYYY")}}</span>
                          </a>

                          <popover v-bind:name="'popup_zone_' + i_zone + '_voie_1'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Date de <span>limite</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="input">
                                    <date-picker format="dd/MM/yyyy" lang="fr" width="300" v-model="new_user.voie_1.date_limite[i_zone]"></date-picker>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                        <span class="choose_date_utilisateur">
                          <a href="javascript:void(0)" v-popover="{name: 'reinit_zone_' + i_zone + '_voie_1'}" class="c-pointer">
                            <i class="fa fa-reply"></i>
                            <span v-if="!new_user.voie_1_heure_reinit[i_zone] || new_user.voie_1_heure_reinit[i_zone] == 0"> 6 heures avant réinitilisation</span>
                            <span v-if="new_user.voie_1_heure_reinit[i_zone] && new_user.voie_1_heure_reinit[i_zone] == 1"> 1 heure avant réinitialisation</span>
                            <span v-if="new_user.voie_1_heure_reinit[i_zone] && new_user.voie_1_heure_reinit[i_zone] > 1"> {{new_user.voie_1_heure_reinit[i_zone]}}  heures avant réinitialisation</span>
                          </a>

                          <popover v-bind:name="'reinit_zone_' + i_zone + '_voie_1'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Heure de <span>réinitialisation</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="row">
                                    <div class="col-6">
                                      <div class="input">
                                        <input type="text" v-model="new_user.voie_1_heure_reinit[i_zone]" placeholder="6" maxlength="2"/>
                                        <b class="tooltip tooltip-bottom-right">Temps en heure permettant le retour à l'état initial (6 heures au maximum)</b>
                                      </div>
                                    </div>
                                    <div class="col-6 pt-10">
                                      heures après
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                      </div>

                      <div class="voie">
                        <label class="switch switch-primary d-inline">
                          <input type="checkbox" @click="toggleCheckedZone(zone, 2, 'zone_' + zone.id_zone + '_voie_2_active', 'new_user')" v-bind:id="'zone_' + zone.id_zone + '_voie_2_active'">
                          <span class="switch-label" data-on="ON" data-off="OFF" ></span>
                          <span class="fs-12">
                            VOIE 2
                          </span>
                        </label>

                        <!-- Ouverture popup -->
                        <span class="choose_date_utilisateur">
                          <a href="javascript:void" v-popover="{name: 'popup_zone_' + i_zone + '_voie_2'}" class="c-pointer pr-10">
                            <i class="fa fa-calendar"></i>
                            <span v-if="!new_user.voie_2.date_limite[i_zone]">Aucune date de limite</span>
                            <span v-else>Limite : {{new_user.voie_2.date_limite[i_zone] | moment("DD/MM/YYYY")}}</span>
                          </a>

                          <popover v-bind:name="'popup_zone_' + i_zone + '_voie_2'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Date de <span>limite</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="input">
                                    <date-picker format="dd/MM/yyyy" lang="fr" width="300" v-model="new_user.voie_2.date_limite[i_zone]"></date-picker>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                        <span class="choose_date_utilisateur">
                          <a href="javascript:void(0)" v-popover="{name: 'reinit_zone_' + i_zone + '_voie_2'}" class="c-pointer">
                            <i class="fa fa-reply"></i>
                            <span v-if="!new_user.voie_2_heure_reinit[i_zone] || new_user.voie_2_heure_reinit[i_zone] == 0"> 6 heures avant réinitilisation</span>
                            <span v-if="new_user.voie_2_heure_reinit[i_zone] && new_user.voie_2_heure_reinit[i_zone] == 1"> 1 heure avant réinitialisation</span>
                            <span v-if="new_user.voie_2_heure_reinit[i_zone] && new_user.voie_2_heure_reinit[i_zone] > 1"> {{new_user.voie_2_heure_reinit[i_zone]}}  heures avant réinitialisation</span>
                          </a>

                          <popover v-bind:name="'reinit_zone_' + i_zone + '_voie_2'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Heure de <span>réinitialisation</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="row">
                                    <div class="col-6">
                                      <div class="input">
                                        <input type="text" v-model="new_user.voie_2_heure_reinit[i_zone]" placeholder="6" maxlength="2"/>
                                        <b class="tooltip tooltip-bottom-right">Temps en heure permettant le retour à l'état initial (6 heures au maximum)</b>
                                      </div>
                                    </div>
                                    <div class="col-6 pt-10">
                                      heures après
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="text-right mt-15 mb-15">
                <a href="javascript:void(0)" class="btn btn-reveal btn-primary" @click="addUser()">
                  <i class="fa fa-plus"></i>
                  <span>Ajouter l'utilisateur</span>
                </a>
              </div>

            </div> <!-- / Creation utilisateur -->

            <!-- Mise a jour utilisateur -->
            <div class="" v-if="utilisateur_action == 'update_utilisateur'">

              <div class="heading-title heading-border-bottom heading-color">
                <h5>Modification <span>utilisateur</span></h5>
              </div>

              <div class="row mt-10 sky-form">

                <div class="col-xl-6 mb-10">
                  <b class="fs-10 text-uppercase">Login de connexion</b>
                  <div class="input">
                    <i class="ico-append fa fa-user"></i>
                    <input type="text" maxlength="50" placeholder="Login" v-model="update_user.datas.login">
                    <b class="tooltip tooltip-bottom-right">Veuillez renseigner un login permettant de connecter l'utilisateur</b>
                  </div>
                </div>

                <div class="col-xl-6 mb-10">
                  <b class="fs-10 text-uppercase">Mot de passe de connexion</b>
                  <div class="input">
                    <i class="ico-append fa fa-lock"></i>
                    <input type="password" maxlength="50" placeholder="Mot de passe" v-model="update_user.datas.new_pass">
                    <b class="tooltip tooltip-bottom-right">Veuillez renseigner un mot de passe permettant de connecter l'utilisateur</b>
                  </div>
                </div>

                <div class="col-xl-6 mb-10">
                  <b class="fs-10 text-uppercase">Description</b>
                  <div class="input">
                    <i class="ico-append fa fa-user"></i>
                    <input type="text" maxlength="50" placeholder="Description" v-model="update_user.datas.description">
                  </div>
                </div>

                <div class="col-xl-6 mb-10">
                  <b class="fs-10 text-uppercase">Date de validité du compte utilisateur</b>
                  <div class="input">
                    <date-picker format="dd/MM/yyyy" lang="fr" width="300" v-model="update_user.datas.date_validite" ></date-picker>
                  </div>
                </div>

              </div>

              <div class="heading-title heading-line-single mt-10">
                <h5>Affecter les <span>zones</span></h5>
              </div>

              <div class="zones-container">
                <div class="zone sky-form mb-10" v-for="(zone, i_zone) in zones">
                  <div class="row">
                    <div class="col-md-4">
                      <div>{{zone.libelle}}</div>
                    </div>

                    <div class="col-md-8">

                      <div class="voie" v-if="update_user.datas.zones[zone.id_zone]">

                        <label class="switch switch-primary d-inline">
                          <input type="checkbox" v-bind:checked="update_user.datas.zones[zone.id_zone].voie_1.is_show" @click="toggleCheckedZone(zone, 1, 'zone_' + zone.id_zone + '_voie_1_active', 'update_user')" v-bind:id="'zone_' + zone.id_zone + '_voie_1_active'">
                          <span class="switch-label" data-on="ON" data-off="OFF" ></span>
                          <span class="fs-12">
                            VOIE 1
                          </span>
                        </label>

                        <!-- Ouverture popup -->
                        <span class="choose_date_utilisateur">
                          <a href="javascript:void(0)" v-popover="{name: 'popup_zone_' + i_zone + '_voie_1'}" class="c-pointer pr-10">
                            <i class="fa fa-calendar"></i>
                            <span v-if="!update_user.datas.zones[zone.id_zone].voie_1.date_limite">Aucune date de limite</span>
                            <span v-else>Limite : {{update_user.datas.zones[zone.id_zone].voie_1.date_limite | moment("DD/MM/YYYY")}}</span>
                          </a>

                          <popover v-bind:name="'popup_zone_' + i_zone + '_voie_1'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Date de <span>limite</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="input">
                                    <date-picker format="dd/MM/yyyy" lang="fr" width="300" v-model="update_user.datas.zones[zone.id_zone].voie_1.date_limite"></date-picker>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                        <span class="choose_date_utilisateur">
                          <a href="javascript:void(0)" v-popover="{name: 'reinit_zone_' + i_zone + '_voie_1'}" class="c-pointer">
                            <i class="fa fa-reply"></i>
                            <span v-if="!update_user.datas.zones[zone.id_zone].voie_1.heure_reinit || update_user.datas.zones[zone.id_zone].voie_1.heure_reinit == 0"> 6 heures avant réinitilisation</span>
                            <span v-if="update_user.datas.zones[zone.id_zone].voie_1.heure_reinit && update_user.datas.zones[zone.id_zone].voie_1.heure_reinit == 1"> 1 heure avant réinitialisation</span>
                            <span v-if="update_user.datas.zones[zone.id_zone].voie_1.heure_reinit && update_user.datas.zones[zone.id_zone].voie_1.heure_reinit > 1"> {{update_user.datas.zones[zone.id_zone].voie_1.heure_reinit}}  heures avant réinitialisation</span>
                          </a>

                          <popover v-bind:name="'reinit_zone_' + i_zone + '_voie_1'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Heure de <span>réinitialisation</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="row">
                                    <div class="col-6">
                                      <div class="input">
                                        <input type="text" v-model="update_user.datas.zones[zone.id_zone].voie_1.heure_reinit" placeholder="6" maxlength="2"/>
                                        <b class="tooltip tooltip-bottom-right">Temps en heure permettant le retour à l'état initial (6 heures au maximum)</b>
                                      </div>
                                    </div>
                                    <div class="col-6 pt-10">
                                      heures après
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                      </div>

                      <div class="voie" v-if="update_user.datas.zones[zone.id_zone]">

                        <label class="switch switch-primary d-inline">
                          <input type="checkbox" v-bind:checked="update_user.datas.zones[zone.id_zone].voie_2.is_show" @click="toggleCheckedZone(zone, 2, 'zone_' + zone.id_zone + '_voie_2_active', 'update_user')" v-bind:id="'zone_' + zone.id_zone + '_voie_2_active'">
                          <span class="switch-label" data-on="ON" data-off="OFF" ></span>
                          <span class="fs-12">
                            VOIE 2
                          </span>
                        </label>

                        <!-- Ouverture popup -->
                        <span class="choose_date_utilisateur">
                          <a href="javascript:void" v-popover="{name: 'popup_zone_' + i_zone + '_voie_2'}" class="c-pointer pr-10">
                            <i class="fa fa-calendar"></i>
                            <span v-if="!update_user.datas.zones[zone.id_zone].voie_2.date_limite">Aucune date de limite</span>
                            <span v-else>Limite : {{update_user.datas.zones[zone.id_zone].voie_2.date_limite | moment("DD/MM/YYYY")}}</span>
                          </a>

                          <popover v-bind:name="'popup_zone_' + i_zone + '_voie_2'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Date de <span>limite</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="input">
                                    <date-picker format="dd/MM/yyyy" lang="fr" width="300" v-model="update_user.datas.zones[zone.id_zone].voie_2.date_limite"></date-picker>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                        <span class="choose_date_utilisateur">
                          <a href="javascript:void(0)" v-popover="{name: 'reinit_zone_' + i_zone + '_voie_2'}" class="c-pointer">
                            <i class="fa fa-reply"></i>
                            <span v-if="!update_user.datas.zones[zone.id_zone].voie_2.heure_reinit || update_user.datas.zones[zone.id_zone].voie_2.heure_reinit == 0"> 6 heures avant réinitilisation</span>
                            <span v-if="update_user.datas.zones[zone.id_zone].voie_2.heure_reinit && update_user.datas.zones[zone.id_zone].voie_2.heure_reinit == 1"> 1 heure avant réinitialisation</span>
                            <span v-if="update_user.datas.zones[zone.id_zone].voie_2.heure_reinit && update_user.datas.zones[zone.id_zone].voie_2.heure_reinit > 1"> {{update_user.datas.zones[zone.id_zone].voie_2.heure_reinit}}  heures avant réinitialisation</span>
                          </a>

                          <popover v-bind:name="'reinit_zone_' + i_zone + '_voie_2'">
                            <div class="popover">
                              <div class="popover-body">

                                <div class="heading-title heading-line-single">
                                  <h6>Heure de <span>réinitialisation</span></h6>
                                </div>

                                <div class="sky-form">
                                  <div class="row">
                                    <div class="col-6">
                                      <div class="input">
                                        <input type="text" v-model="update_user.datas.zones[zone.id_zone].voie_2.heure_reinit" placeholder="6" maxlength="2"/>
                                        <b class="tooltip tooltip-bottom-right">Temps en heure permettant le retour à l'état initial (6 heures au maximum)</b>
                                      </div>
                                    </div>
                                    <div class="col-6 pt-10">
                                      heures après
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </popover>
                        </span>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="text-center mt-15 mb-15">
                <div class="row">

                  <div class="col-12 text-right">

                    <a href="javascript:void(0)" class="btn btn-reveal btn-red" @click="cancelUpdateUser()">
                      <i class="fa fa-close"></i>
                      <span>Annuler les modifications</span>
                    </a>

                    <a href="javascript:void(0)" class="btn btn-reveal btn-primary" @click="validUpdateUser()">
                      <i class="fa fa-check"></i>
                      <span>Modifier l'utilisateur</span>
                    </a>
                  </div>

                </div>
              </div>

            </div> <!-- / Fin update utilisateur -->

            <div>
              <transition name="fade">
                <div class="alert alert-danger mb-10" v-if="new_user.is_error || update_user.is_error">
                  <button type="button" class="close" data-dismiss="alert" @click.prevent="new_user.is_error = false; update_user.is_error = false">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                  </button>
                  <strong>Erreur !</strong> Veuillez vérifier les informations !
                </div>
              </transition>
            </div>

            <div>
              <transition name="fade">
                <div class="alert alert-danger mb-10" v-if="new_user.is_error_heure_reinit || update_user.is_error_heure_reinit">
                  <button type="button" class="close" data-dismiss="alert" @click.prevent="new_user.is_error_heure_reinit = false; update_user.is_error_heure_reinit = false">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                  </button>
                  <strong>Erreur !</strong> L'heure de réinitialisation est de 6 heures au maximum !
                </div>
              </transition>
            </div>

            <div>
              <transition name="fade">
                <div class="alert alert-danger mb-10" v-if="new_user.is_error_existant || update_user.is_error_existant">
                  <button type="button" class="close" data-dismiss="alert" @click.prevent="new_user.is_error_existant = false; update_user.is_error_existant = false">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                  </button>
                  <strong>Erreur !</strong> Login existant... Veuillez choisir un login différent !
                </div>
              </transition>
            </div>

            <div class="heading-title heading-line-single mt-10">
              <h5>Liste des <span>utilisateurs</span></h5>
            </div>

            <div class="mt-5 mt-20">
              <div class="table-responsive">
                <table class="table table-striped table-vertical-middle fs-14">
                  <thead>
                    <tr>
                      <th>Login</th>
                      <th>Description</th>
                      <th>Date de validité</th>
                      <th>Actif</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, i_user) in users">
                      <td>
                        {{user.login}}
                      </td>
                      <td>{{user.description}}</td>
                      <td>
                        {{user.date_validite | moment("DD/MM/YYYY")}}
                      </td>
                      <td>
                        <label class="switch switch-primary">
                          <input type="checkbox" v-bind:checked="user.is_actif" @click="updateStatus(i_user, 'active_user_' + i_user)" v-bind:id="'active_user_' + i_user">
                          <span class="switch-label" data-on="OUI" data-off="NON"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <a href="javascript:void(0)" class="btn btn-outline-secondary btn-sm" @click.prevent="editUser(i_user)">
                          <i class="fa fa-edit white pr-0"></i>
                        </a>
                        <a href="javascript:void(0)" class="btn btn-outline-secondary btn-sm" @click.prevent="removeUser(i_user)">
                          <i class="fa fa-times white pr-0"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ZONES -->
          <div v-if="current_page == 'ZONE'">

            <transition name="fade">
              <div class="info-bar info-bar-color save-container" v-if="is_modification_zone_en_cours">
                <div class="container">
                  <div class="row">

                    <div class="col-6">

                      <button type="button" class="btn btn-block btn-translucid cancel" @click.prevent="cancelModification()">
                        <i class="fa fa-close"></i>
                        ANNULER
                      </button>

                    </div>

                    <div class="col-6">

                      <button type="button" class="btn btn-block btn-translucid valid" @click.prevent="saveVoie()">
                        <i class="fa fa-check"></i>
                        ENREGISTRER
                      </button>

                    </div>

                  </div>
                </div>

              </div>
            </transition>

            <div class="container">
              <div class="heading-title heading-border-bottom heading-color c-pointer">
                <h5>Informations de la zone <span>{{zone.libelle}}</span></h5>
              </div>

              <div class="alert alert-theme-color mb-20 mt-20" v-if="zone && zone.api_free && (!zone.api_free.telephone || !zone.api_free.user || !zone.api_free.apikey)">
                <strong>Vous venez de créer une zone !</strong>
                <div>Il ne vous reste plus qu'à la configurer depuis le menu de configuration avancée juste en dessous.</div>
              </div>

            </div>

            <div class="mt-20 sky-form">

              <transition name="fade">
                <div class="">

                  <div class="container">

                    <ul class="nav nav-tabs nav-clean">
                      <li class="nav-item">
                        <a v-bind:class="{'nav-link': true, 'active': index_menu == 1}" href="javascript:void(0)" id="home-tab_2" @click="index_menu = 1"><i class="fa fa-info"></i> Informations</a>
                      </li>
                      <li class="nav-item">
                        <a v-bind:class="{'nav-link': true, 'active': index_menu == 2}" href="javascript:void(0)" id="profile-tab_2" v-if="user && user.is_admin" @click.prevent="toggleLogsZone()"><i class="fa fa-list"></i> Logs</a>
                      </li>
                      <li class="nav-item">
                        <a v-bind:class="{'nav-link': true, 'active': index_menu == 3}" href="javascript:void(0)" id="profile-tab_2" v-if="user && user.is_admin" @click.prevent="index_menu = 3"><i class="fa fa-cog"></i> Configuration avancée</a>
                      </li>
                    </ul>

                    <div class="row" v-if="index_menu == 1">

                      <div class="col-12 mt-10">

                        <h6>Nom de la zone</h6>

                        <div>
                          {{zone.libelle}}
                        </div>
                      </div>

                      <div class="col-12 mt-10 mb-10">

                        <h6>Etat armoire</h6>

                        <div v-if="!zone.date_ouverture_porte">Fermé</div>
                        <div v-if="zone.date_ouverture_porte">Ouverte depuis le {{zone.date_ouverture_porte}}</div>
                      </div>

                    </div>

                    <!-- AFFICHAGE LOGS -->
                    <div class="row" v-if="index_menu == 2">

                      <div class="col-12">

                        <table class="table table-striped table-vertical-middle mt-15 fs-14">

                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Login</th>
                              <th>Nom</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>

                            <tr v-if="!zone.logs || zone.logs.length == 0">
                              <td colspan="4">Aucun logs</td>
                            </tr>

                            <tr v-for="log in zone.logs">
                              <td>{{log.date | moment("DD/MM/YYYY HH:mm:ss")}}</td>
                              <td>{{log.login}}</td>
                              <td>{{log.description}}</td>
                              <td>{{log.action}}</td>
                            </tr>

                          </tbody>

                        </table>
                      </div>
                    </div>

                    <!-- CONFIGURATION AVANCEE -->
                    <div class="row" v-if="index_menu == 3">

                      <div class="col-12 mt-10" v-if="!zone.is_edit">

                        <h6>Nom de la zone</h6>

                        <div>
                          {{zone.libelle}}
                        </div>

                      </div>

                      <div class="col-12 mt-10" v-if="zone.is_edit">
                        <h6>Nom de la zone</h6>
                        <label class="input">
                          <i class="ico-append fa fa-map-signs"></i>
                          <input type="text" maxlength="200" v-model="zone.libelle" placeholder="Nom de la zone" v-on:keyup.enter="validZone()"/>
                          <b class="tooltip tooltip-bottom-right">Nom de la zone</b>
                        </label>
                      </div>

                      <div class="col-xl-6 mt-10" v-if="!zone.is_edit">
                        <h6>Téléphone</h6>
                        <div v-if="zone && zone.api_free && zone.api_free.telephone">
                          {{zone.api_free.telephone}}
                        </div>
                        <div v-if="zone && (!zone.api_free || !zone.api_free.telephone)">
                          Non renseigné
                        </div>
                      </div>

                      <div class="col-xl-6 mt-10" v-if="zone.is_edit">
                        <h6>Téléphone</h6>
                        <label class="input" v-if="zone.is_edit">
                          <i class="ico-append fa fa-phone"></i>
                          <input type="text" maxlength="200" v-model="zone.api_free.telephone" placeholder="Numéro de téléphone" v-on:keyup.enter="validZone()"/>
                          <b class="tooltip tooltip-bottom-right">Numéro de téléphone nécéssaire à l'envoi des commandes</b>
                        </label>
                      </div>

                      <div class="col-xl-6 mt-10" v-if="!zone.is_edit">
                        <h6>Utilisateur</h6>

                        <div v-if="zone && zone.api_free && zone.api_free.user">
                          {{zone.api_free.user}}
                        </div>
                        <div v-if="zone && (!zone.api_free || !zone.api_free.user)">
                          Non renseigné
                        </div>
                      </div>

                      <div class="col-xl-6 mt-10" v-if="zone.is_edit">
                        <b>Utilisateur</b>
                        <label class="input" v-if="zone.is_edit">
                          <i class="ico-append fa fa-user"></i>
                          <input type="text" maxlength="200" v-model="zone.api_free.user" placeholder="Utilisateur" v-on:keyup.enter="validZone()"/>
                          <b class="tooltip tooltip-bottom-right">Utilisateur Free</b>
                        </label>
                      </div>

                      <div class="col-xl-6 mt-10" v-if="!zone.is_edit">
                        <h6>Apikey</h6>

                        <div v-if="zone && zone.api_free">
                          {{zone.api_free.apikey}}
                        </div>
                        <div v-if="zone && (!zone.api_free || !zone.api_free.apikey)">
                          Non renseigné
                        </div>

                      </div>

                      <div class="col-xl-6 mt-10" v-if="zone.is_edit">
                        <b>Apikey</b>
                        <label class="input" v-if="zone.is_edit">
                          <i class="ico-append fa fa-user"></i>
                          <input type="text" maxlength="200" v-model="zone.api_free.apikey" placeholder="Apikey" v-on:keyup.enter="validZone()"/>
                          <b class="tooltip tooltip-bottom-right">Apikey de Free</b>
                        </label>
                      </div>

                      <div class="col-xl-6 mt-10" v-if="!zone.is_edit">
                        <div>
                          <h6>Identifiant</h6>
                        </div>

                        <div>
                          {{zone.identifiant}}
                        </div>
                      </div>

                      <div class="col-xl-6 mt-10" v-if="zone.is_edit">
                        <b>Identifiant</b>
                        <label class="input" v-if="zone.is_edit">
                          <i class="ico-append fa fa-user"></i>
                          <input type="text" maxlength="200" v-model="zone.identifiant" placeholder="Identifiant" v-on:keyup.enter="validZone()"/>
                          <b class="tooltip tooltip-bottom-right">Identifiant de la zone</b>
                        </label>
                      </div>

                      <div class="col-12">

                        <div class="row">

                          <div class="col-xl-4 mt-10">
                            <a href="javascript:void(0)" v-if="user && user.is_admin && !zone.is_edit" @click.prevent="editZone()" class="w-100p btn btn-outline-secondary btn-sm mb-10">
                              <i class="fa fa-edit white"></i>
                              Modifier la configuration
                            </a>
                            <a href="javascript:void(0)" v-if="zone.is_edit" @click.prevent="validZone()" class="w-100p btn btn-primary btn-sm mb-10">
                              <i class="fa fa-check white"></i>
                              Valider la configuration
                            </a>
                          </div>

                          <div class="col-xl-4 mt-10">
                            <a href="javascript:void(0)" class="w-100p btn btn-outline-secondary btn-sm mb-10" v-if="user && user.is_admin" @click.prevent="testerConfig()">
                              <i class="fa fa-reply white"></i>
                              Tester la configuration
                            </a>
                          </div>

                          <div class="col-xl-4 mt-10">
                            <a href="javascript:void(0)" class="w-100p btn btn-outline-secondary btn-sm mb-10" v-if="user && user.is_admin" @click.prevent="modalRemoveZone()">
                              <i class="fa fa-exclamation-triangle white"></i>
                              Supprimer la zone
                            </a>
                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

              </transition>

              <div class="">

                <div class="zoneInError" v-if="zone && zone.is_erreur_reception">
                  <p>Aucune réception</p>
                </div>

                <div class="container">

                  <div class="d-flex d-justify-content-center">
                    <div class="heading-title heading-line-single mt-20 mb-0">
                      <h5>Voie 1
                        <span v-if="zone.voies && zone.voies[0].is_allume" class="color-green">
                          Allumée
                        </span>
                        <span v-else class="color-black">
                          Eteinte
                        </span>
                        <i class="fs-10">
                          Mode
                        </i>
                        <i v-if="zone.voies && zone.voies[0].is_crepusculaire" class="fs-10">
                          crépusculaire
                        </i>
                        <i v-else class="fs-10">
                          horaire
                        </i>
                        <i v-if="zone.voies && zone.voies[0].is_allume_actif" class="fs-10">
                          / forçage activé
                        </i>
                      </h5>
                    </div>
                  </div>

                  <div class="mt-10" v-if="zone.voies && zone.voies[0]">
                    <label class="checkbox fs-14">
                      <input type="checkbox" v-bind:checked="zone.voies[0].is_crepusculaire" v-model="zone.voies[0].is_crepusculaire" @click="toggleCrepusculaire(0)">
                      <i></i> <b>Mode crépusculaire ?</b>
                      <small>Gestion de l'éclairage en fonction du lever / coucher du soleil (aujourd'hui de 00:00 à {{heure_levee_soleil_moment | moment("HH:mm")}} et de {{heure_coucher_soleil_moment | moment("HH:mm")}} à 23h55).</small>
                    </label>
                  </div>

                  <div class="mt-10">

                    <div class="input">

                      <div class="row">
                        <div class="col-xl-6 mb-5 b-dotted-right">

                          <!-- Ajouter une tranche horaire -->
                          <div class="row" v-if="zone && zone.voies && zone.voies[0] && !zone.voies[0].is_crepusculaire">

                            <div class="col-12">
                              <a href="javascript:void(0)" class="btn btn-primary btn-reveal btn-sm w-100p" @click="modalAddHoraire(0)">
                                <i class="fa fa-plus"></i>
                                <span>Ajouter une tranche horaire d'allumage</span>
                              </a>
                            </div>

                          </div>

                          <!-- Exclure une tranche horaire -->
                          <div class="row" v-if="zone && zone.voies && zone.voies[0] && zone.voies[0].is_crepusculaire">

                            <div class="col-12">
                              <a href="javascript:void(0)" class="btn btn-dark btn-reveal btn-sm w-100p" @click="modalExclureHoraire(0)">
                                <i class="fa fa-minus"></i>
                                <span>Exclure la tranche horaire</span>
                              </a>
                            </div>

                            <div class="col-12" v-if="zone && zone.voies && zone.voies[0] && zone.voies[0].is_crepusculaire">
                              <div class="mt-5" v-for="(horaire_exclusion, i_horaire_exclusion) in zone.voies[0].interval_exclusion_allumage" @click.prevent="removeExclusionHoraire(0, i_horaire_exclusion)">
                                <span class="c-pointer fs-12" title="Supprimer l'exclusion">
                                  <i class="fa fa-close c-red"></i>
                                  Exclusion de {{horaire_exclusion.debut}} à {{horaire_exclusion.fin}}
                                </span>
                              </div>
                            </div>

                          </div>

                        </div>

                        <div class="col-xl-6 text-right">

                          <div class="row">

                            <div class="col-12">

                              <button type="button" class="btn btn-sm btn-outline-secondary float-left w-100p mb-5" @click.prevent="openModalException(0)">
                                <i class="fa fa-plus"></i> Ajouter une exception
                              </button>

                            </div>

                            <div class="col-12">

                              <div>
                                <button type="button" class="btn btn-sm btn-outline-secondary w-100p mb-5" @click.prevent="modalGoForcage(0)">
                                  <i class="fa fa-podcast"></i> Forcer
                                  <span v-if="zone.voies && !zone.voies[0].is_allume">l'allumage</span>
                                  <span v-else>l'extinction</span>
                                </button>

                                <b class="tooltip tooltip-bottom-right">Force <span v-if="zone.voies && !zone.voies[0].is_allume">l'allumage</span><span v-else>l'extinction</span> de cette voie, elle retournera à son état initial dans 6 heures.</b>

                              </div>

                              <div v-if="zone.voies && zone.voies[0].is_allume_actif">
                                <button type="button" class="btn btn-sm btn-outline-secondary w-100p mb-5" @click.prevent="modalStopForcage(0)">
                                  Arrêt du forçage
                                </button>
                                <b class="tooltip tooltip-bottom-right">Arrête le forçage de cette voie pour revenir en mode <span v-if="zone.voies && zone.voies[0].is_crepusculaire">crépusculaire</span><span v-else>horaire</span>.</b>
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

                <div class="mt-30 d-flex justify-content-center">
                  <div v-bind:id="'schedule_0'" class="schedule"></div>
                </div>

                <div class="container">

                  <div class="">
                    <div class="heading-title heading-line-single mt-40 mb-0">
                      <h5>Voie 2
                        <span v-if="zone.voies && zone.voies[1].is_allume" class="color-green">
                          Allumée
                        </span>
                        <span v-else class="color-black">
                          Eteinte
                        </span>
                        <i class="fs-10">
                          Mode
                        </i>
                        <i v-if="zone.voies && zone.voies[1].is_crepusculaire" class="fs-10">
                          crépusculaire
                        </i>
                        <i v-else class="fs-10">
                          horaire
                        </i>
                        <i v-if="zone.voies && zone.voies[1].is_allume_actif" class="fs-10">
                          / forçage activé
                        </i>
                      </h5>
                    </div>
                  </div>

                  <div class="mt-10" v-if="zone.voies && zone.voies[1]">
                    <label class="checkbox fs-14">
                      <input type="checkbox" v-bind:checked="zone.voies[1].is_crepusculaire" v-model="zone.voies[1].is_crepusculaire" @click="toggleCrepusculaire(1)">
                      <i></i> <b>Mode crépusculaire ?</b>
                      <small>Gestion de l'éclairage en fonction du lever / coucher du soleil (aujourd'hui de 00:00 à {{heure_levee_soleil_moment | moment("HH:mm")}} et de {{heure_coucher_soleil_moment | moment("HH:mm")}} à 23h55).</small>
                    </label>
                  </div>

                  <div class="mt-10">

                    <div class="input">

                      <div class="row">
                        <div class="col-xl-6 mb-5 b-dotted-right">

                          <!-- Ajouter une tranche horaire -->
                          <div class="row" v-if="zone && zone.voies && zone.voies[1] && !zone.voies[1].is_crepusculaire">

                            <div class="col-12">
                              <a href="javascript:void(0)" class="btn btn-primary btn-reveal btn-sm w-100p" @click="modalAddHoraire(1)">
                                <i class="fa fa-plus"></i>
                                <span>Ajouter une tranche horaire d'allumage</span>
                              </a>
                            </div>

                          </div>

                          <!-- Exclure une tranche horaire -->
                          <div class="row" v-if="zone && zone.voies && zone.voies[1] && zone.voies[1].is_crepusculaire">

                            <div class="col-12">
                              <a href="javascript:void(0)" class="btn btn-dark btn-reveal btn-sm w-100p" @click="modalExclureHoraire(1)">
                                <i class="fa fa-minus"></i>
                                <span>Exclure la tranche horaire</span>
                              </a>
                            </div>

                            <div class="col-12" v-if="zone && zone.voies && zone.voies[1] && zone.voies[1].is_crepusculaire">
                              <div class="mt-5" v-for="(horaire_exclusion, i_horaire_exclusion) in zone.voies[1].interval_exclusion_allumage" @click.prevent="removeExclusionHoraire(1, i_horaire_exclusion)">
                                <span class="c-pointer fs-12" title="Supprimer l'exclusion">
                                  <i class="fa fa-close c-red"></i>
                                  Exclusion de {{horaire_exclusion.debut}} à {{horaire_exclusion.fin}}
                                </span>
                              </div>
                            </div>

                          </div>

                        </div>

                        <div class="col-xl-6 text-right">

                          <div class="row">

                            <div class="col-12">

                              <button type="button" class="btn btn-sm btn-outline-secondary float-left w-100p mb-5" @click.prevent="openModalException(1)">
                                <i class="fa fa-plus"></i> Ajouter une exception
                              </button>

                            </div>

                            <div class="col-12">

                              <div>
                                <button type="button" class="btn btn-sm btn-outline-secondary w-100p mb-5" @click.prevent="modalGoForcage(1)">
                                  <i class="fa fa-podcast"></i> Forcer
                                  <span v-if="zone.voies && !zone.voies[1].is_allume">l'allumage</span>
                                  <span v-else>l'extinction</span>
                                </button>

                                <b class="tooltip tooltip-bottom-right">Force <span v-if="zone.voies && !zone.voies[1].is_allume">l'allumage</span><span v-else>l'extinction</span> de cette voie, elle retournera à son état initial dans 6 heures.</b>

                              </div>

                              <div v-if="zone.voies && zone.voies[1].is_allume_actif">
                                <button type="button" class="btn btn-sm btn-outline-secondary w-100p mb-5" @click.prevent="modalStopForcage(1)">
                                  Arrêt du forçage
                                </button>
                                <b class="tooltip tooltip-bottom-right">Arrête le forçage de cette voie pour revenir en mode <span v-if="zone.voies && zone.voies[1].is_crepusculaire">crépusculaire</span><span v-else>horaire</span>.</b>
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

                <div class="mt-30 d-flex justify-content-center">
                  <div v-bind:id="'schedule_1'" class="schedule"></div>
                </div>

              </div>

            </div>


          </div>

          <!-- MON COMPTE -->
          <div class="container" v-if="current_page == 'COMPTE'">

            <div class="heading-title heading-border-bottom heading-color">
              <h5>Modification <span>compte</span></h5>
            </div>

            <div class="row mt-10 sky-form">

              <div class="col-xl-6 mb-10">
                <h6>Ville</h6>
                <div class="input">
                  <i class="ico-append fa fa-map-marker"></i>
                  <input type="text" v-bind:placeholder="ville.nom" disabled="true">
                </div>
              </div>

              <div class="col-xl-6 mb-10">
                <h6>Code postal</h6>
                <div class="input">
                  <i class="ico-append fa fa-map-marker"></i>
                  <input type="text" disabled="true" v-bind:placeholder="ville.code_postal">
                </div>
              </div>

              <div class="col-xl-6 mb-10">
                <h6>Login de connexion</h6>
                <div class="input">
                  <i class="ico-append fa fa-user"></i>
                  <input type="text" maxlength="50" v-model="new_login" v-bind:placeholder="user.login" v-on:keyup.enter="majCompte()">
                  <b class="tooltip tooltip-bottom-right">Changer votre login</b>
                </div>
              </div>

              <div class="col-xl-6 mb-10">
                <h6>Nouveau mot de passe de connexion</h6>
                <div class="input">
                  <i class="ico-append fa fa-lock"></i>
                  <input type="password" maxlength="50" v-model="new_pass" placeholder="Modification du mot de passe" v-on:keyup.enter="majCompte()">
                  <b class="tooltip tooltip-bottom-right">Modification de votre mot de passe</b>
                </div>
              </div>

              <div class="col-md-12 mb-10">
                <h6>Email de réception des avertissements</h6>
                <div class="input">
                  <i class="ico-append fa fa-envelope"></i>
                  <input type="email" maxlength="100" v-model="user.email" v-bind:placeholder="user.email" v-on:keyup.enter="majCompte()">
                  <b class="tooltip tooltip-bottom-right">Recevez depuis cette adresse email un avertissement sur les zones qui ne répondent plus.</b>
                </div>
              </div>

              <div class="col-12">
                <transition name="fade">
                  <div class="alert alert-danger mb-15" v-if="account.is_error">
                    <button type="button" class="close" data-dismiss="alert" @click="account.is_error = false">
                      <span aria-hidden="true">×</span>
                      <span class="sr-only">Close</span>
                    </button>
                    <strong>Erreur !</strong> Veuillez vérifier les informations.
                  </div>
                </transition>

              </div>

              <div class="col-12">
                <div class="text-right">
                  <a href="javascript:void(0)" class="btn btn-reveal btn-primary" @click="majCompte()">
                    <i class="fa fa-refresh"></i>
                    <span>Mettre à jour les informations</span>
                  </a>
                </div>
              </div>

            </div>
          </div>

        </transition>

      </div>

    </div>

    <div class="carte" id="carte-google"></div>

    <div class="describe-logs">

      <div class="heading-title heading-border-bottom heading-color text-right mb-4">
        <h6>Derniers <span>logs</span></h6>
      </div>

      <div class="" v-if="logs && logs[0]">
        <div>{{logs[0].date | moment("DD/MM/YYYY HH:mm:ss")}} par <b>{{logs[0].login}}</b></div>
        <div>{{logs[0].action}}</div>
      </div>
      <div class="pt-5" v-if="logs && logs[1]">
        <div>{{logs[1].date | moment("DD/MM/YYYY HH:mm:ss")}} par <b>{{logs[1].login}}</b></div>
        <div>{{logs[1].action}}</div>
      </div>
    </div>

    <!-- Descriptif général -->
    <div class="describe-general">

      <div class="heading-title heading-border-bottom heading-color mb-4">
        <h6>Etat <span>général</span></h6>
      </div>

      <div class="row">

        <div class="col-4 pr-0 pt-10">

          <div class="mb-5">

            <div v-if="is_etat_general_ok">
              <i class="fa fa-check"></i> Rien à signaler
            </div>

            <div v-else>
              <i class="fa fa-close c-red"></i> Problème signalé
            </div>
          </div>

          <div class="mb-10">
            <div class="pr-10">
              <i class="fa fa-sun-o"></i> {{meteo.heure_levee_soleil}}
            </div>
            <div>
              <i class="fa fa-moon-o"></i> {{meteo.heure_coucher_soleil}}
            </div>
          </div>

        </div>

        <div class="col-8">

          <div class="legend legend-ok">
            Zone allumée
          </div>

          <div class="legend legend-mi-ok">
            Zone partiel. allumée
          </div>

          <div class="legend legend-none">
            Zone éteinte
          </div>

          <div class="legend legend-ko">
            Zone en erreur
          </div>

        </div>

      </div>

    </div>

    <!-- Descriptif rapide de la zone -->
    <transition name="fade">
      <div class="describe-zone" v-if="zone_over">

        <div class="text-left">
          <b>{{zone_over.libelle}}</b>
        </div>

        <div class="divider divider-center divider-color mt-0 mb-0">
          <i class="fa fa-chevron-down"></i>
        </div>

        <div class="">

          <div v-if="zone_over.is_erreur_reception">
            <i class="fa fa-close c-red"></i>
            Problème de réception
          </div>

          <div v-else>
            <i class="fa fa-check"></i>
            Réception OK
          </div>

          <div v-if="zone_over.date_ouverture_porte">
            <i class="fa fa-close c-red"></i>
            Armoire ouverte depuis {{zone_over.date_ouverture_porte}}
          </div>

          <div v-else>
            <i class="fa fa-check"></i>
            Armoire fermée
          </div>

        </div>

      </div>
    </transition>

    <div class="d-none">

      <div id="modal-remove-zone">
        <div class="">
          <div class="text-center">
            <img src="/static/assets/img/delete.png" width="64px"/>
          </div>
          <div class="text-center pb-30 pt-30">
            Êtes-vous sûr de vouloir supprimer une zone d'éclairage ?
          </div>
          <div class="row justify-content-center">
            <div class="col-md-3 mb-10">
              <a href="javascript:void(0)" class="btn btn-primary btn-reveal w-100p" @click="removeZone()">
                <i class="fa fa-trash"></i>
                <span>Oui</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div id="modal-delete">
        <div class="text-center mb-30" v-if="remove_horaire[modal_voie_en_cours]">
          <i class="fa fa-calendar-times-o"></i> Etes-vous sûr de vouloir supprimer l'horaire d'allumage
          <strong>{{remove_horaire[modal_voie_en_cours].debut}} - {{remove_horaire[modal_voie_en_cours].fin}}</strong> ?
        </div>
        <div class="row justify-content-center">
          <div class="col-md-3 mb-10">
            <a href="javascript:void(0)" class="btn btn-primary btn-reveal w-100p" @click="removeHoraire(remove_horaire[modal_voie_en_cours].i_v, remove_horaire[modal_voie_en_cours].i_h)">
              <i class="fa fa-trash"></i>
              <span>Oui, je souhaite supprimer la tranche horaire</span>
            </a>
          </div>
        </div>
      </div>

      <div id="modal-stop-forcage">
        <div class="">
          <div class="text-center">
            <img src="/static/assets/img/brightness.png" width="64px"/>
          </div>
          <div class="text-center pb-20 pt-30">
            Vous êtes sur le point d'arrêter un forçage et de revenir en mode <span v-if="zone.voies && zone.voies[modal_voie_en_cours].is_crepusculaire">crépusculaire</span><span v-else>horaire</span>.<br/> Êtes-vous sûr ?
          </div>
          <div class="col-12 text-center pb-30">
            <a href="javascript:void(0)" class="btn btn-primary btn-reveal btn-sm" @click="stopForcage(modal_voie_en_cours)">
              <i class="fa fa-check"></i>
              <span>Oui, je souhaite arrêter le forçage</span>
            </a>
          </div>
        </div>
      </div>

      <div id="modal-toggle-forcage">
        <div class="">
          <div class="text-center">
            <img src="/static/assets/img/light-bulb.png" width="64px"/>
          </div>
          <div class="text-center pb-20 pt-30" v-if="zone.voies && zone.voies[modal_voie_en_cours].is_allume">
            Vous êtes sur le point d'éteindre une zone public.<br/> Êtes-vous sûr ?
          </div>
          <div class="text-center pb-20 pt-30" v-else>
            Vous êtes sur le point d'allumer une zone public.<br/> Êtes-vous sûr ?
          </div>
          <div class="col-12 text-center pb-30">
            <a href="javascript:void(0)" class="btn btn-primary btn-reveal btn-sm" @click="goForcage(modal_voie_en_cours)">
              <i class="fa fa-check"></i>
              <span v-if="zone.voies && zone.voies[modal_voie_en_cours].is_allume">Oui, je souhaite éteindre cette zone</span>
              <span v-else>Oui, je souhaite allumer cette zone</span>
            </a>
          </div>
        </div>
      </div>

      <div id="modal-crepusculaire">
        <div class="">
          <div class="text-center">
            <img src="/static/assets/img/cancel.png" width="64px"/>
          </div>
          <div class="text-center pb-30 pt-30">
            En mode crépusculaire vous ne pouvez pas supprimer de tranche horaire.
          </div>
        </div>
      </div>

      <div id="modal-test-ok">
        <div class="">
          <div class="text-center">
            <img src="/static/assets/img/checked.png" width="64px"/>
          </div>
          <div class="text-center pb-30 pt-30">
            Test réussi.
          </div>
        </div>
      </div>

      <div id="modal-test-ko">
        <div class="">
          <div class="text-center">
            <img src="/static/assets/img/cancel.png" width="64px"/>
          </div>
          <div class="text-center pb-30 pt-30">
            Test en échec.
          </div>
        </div>
      </div>

      <div id="modal-add-exclusion">
        <div class="container pb-30 pt-30">
          <div class="row sky-form">

            <div class="col-xl-6">
              <span style="position:relative" class="input">
                <i class="ico-append fa fa-clock-o"></i>
                <the-mask type="text" v-model="exclure_horaire[modal_voie_en_cours].debut" :mask="['##:##']" :masked="true" placeholder="Hor. déb. (HH:MM)" v-on:keyup.enter="exclureHoraire(modal_voie_en_cours)" class="d-inline mb-10"></the-mask>
                <b class="tooltip tooltip-bottom-right">Horaire de début au format heure:minute</b>
              </span>
            </div>

            <div class="col-xl-6">
              <span style="position:relative" class="input">
                <i class="ico-append fa fa-clock-o"></i>
                <the-mask type="text" v-model="exclure_horaire[modal_voie_en_cours].fin" :mask="['##:##']" :masked="true" placeholder="Hor. fin (HH:MM)" v-on:keyup.enter="exclureHoraire(modal_voie_en_cours)" class="d-inline mb-10"></the-mask>
                <b class="tooltip tooltip-bottom-right">Horaire de fin au format heure:minute</b>
              </span>
            </div>

            <div class="col-12 text-center mt-20">
              <a href="javascript:void(0)" class="btn btn-dark btn-reveal btn-sm" @click="exclureHoraire(modal_voie_en_cours)">
                <i class="fa fa-minus"></i>
                <span>Ajouter la tranche horaire d'exclusion</span>
              </a>
            </div>

          </div>
        </div>
      </div>

      <div id="modal-add-horaire">
        <div class="container pb-30 pt-30">
          <div class="row sky-form">
            <div class="col-xl-6">
              <span style="position:relative" class="input">
                <i class="ico-append fa fa-clock-o"></i>
                <the-mask type="text" v-model="add_horaire[modal_voie_en_cours].debut" :mask="['##:##']" :masked="true" placeholder="Hor. déb. (HH:MM)" v-on:keyup.enter="addHoraire(modal_voie_en_cours)" class="d-inline mb-10"></the-mask>
                <b class="tooltip tooltip-bottom-right">Horaire de début au format heure:minute</b>
              </span>
            </div>

            <div class="col-xl-6">
              <span style="position:relative" class="input">
                <i class="ico-append fa fa-clock-o"></i>
                <the-mask type="text" v-model="add_horaire[modal_voie_en_cours].fin" :mask="['##:##']" :masked="true" placeholder="Hor. fin (HH:MM)" v-on:keyup.enter="addHoraire(modal_voie_en_cours)" class="d-inline mb-10"></the-mask>
                <b class="tooltip tooltip-bottom-right">Horaire de fin au format heure:minute</b>
              </span>
            </div>

            <div class="col-12 text-center mt-20">
              <a href="javascript:void(0)" class="btn btn-primary btn-reveal btn-sm" @click="addHoraire(modal_voie_en_cours)">
                <i class="fa fa-plus"></i>
                <span>Ajouter la tranche horaire</span>
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="d-none">

      <div id="modal-exception">

        <div class="monthly" id="mycalendar"></div>

        <div class="row">
          <div class="col-12 pl-30 pr-30 pb-10">
            <div class="row">
              <div class="col-md-4">
                <div class="sky-form">

                  <div class="input mt-5 mb-5">
                    <label>
                      <b>Nom de l'événement</b>
                      <input type="text" v-model="add_horaire_exception.evenement_exclusion" placeholder="Événement..." maxlength="50"/>
                    </label>
                  </div>
                  <div class="input">
                    <label>
                      <b>Date de l'événement</b>
                    </label>
                    <date-picker format="dd/MM/yyyy" lang="fr" v-model="add_horaire_exception.date_exclusion"></date-picker>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="sky-form">

                  <div class="input mt-5 mb-5">
                    <label class="input">
                      <b>Horaire de début</b>
                      <the-mask type="text" v-model="add_horaire_exception.heure_debut_exclusion" :mask="['##:##']" :masked="true" placeholder="Horaire début (HH:MM)"></the-mask>
                      <b class="tooltip tooltip-bottom-right">Horaire de début au format heure:minute</b>
                    </label>
                  </div>
                  <div class="input mt-5 mb-5">
                    <label class="input">
                      <b>Horaire de fin</b>
                      <the-mask type="text" v-model="add_horaire_exception.heure_fin_exclusion" :mask="['##:##']" :masked="true" placeholder="Horaire fin (HH:MM)"></the-mask>
                      <b class="tooltip tooltip-bottom-right">Horaire de fin au format heure:minute</b>
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-4 ">

                <div style="height: 50%" class="d-flex align-items-stretch">
                  <div class="w-100p input mt-auto">
                    <label class="switch switch-primary">
                      <input type="checkbox" v-model="add_horaire_exception.is_allumage"/>
                      <span class="switch-label" data-on="ON" data-off="OFF"></span>
                      <span class="fs-12">
                        Allumage ?
                      </span>
                    </label>
                  </div>
                </div>

                <div style="height: 50%" class="d-flex align-items-stretch">
                  <div class="w-100p input mt-auto mb-8">
                    <a href="javascript:void(0)" class="w-100p btn btn-reveal btn-primary" @click.prevent="addHoraireException(modal.i_v)">
                      <i class="fa fa-plus"></i>
                      <span>Ajouter une exception</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-12">
                <transition name="fade">
                  <div class="alert alert-danger mb-10 mt-5" v-if="add_horaire_exception.is_error">
                    <button type="button" class="close" data-dismiss="alert" @click="add_horaire_exception.is_error = false">
                      <span aria-hidden="true">×</span>
                      <span class="sr-only">Close</span>
                    </button>
                    <strong>Erreur !</strong> Veuillez vérifier les informations.
                  </div>
                </transition>
                <transition name="fade">
                  <div class="alert alert-danger mb-10 mt-5" v-if="add_horaire_exception.is_error_date_before_now">
                    <button type="button" class="close" data-dismiss="alert" @click="add_horaire_exception.is_error_date_before_now = false">
                      <span aria-hidden="true">×</span>
                      <span class="sr-only">Close</span>
                    </button>
                    <strong>Erreur !</strong> Vous ne pouvez pas ajouter un évènement avec une date antérieur à la date du jour.
                  </div>
                </transition>
                <transition name="fade">
                  <div class="alert alert-danger mb-10 mt-5" v-if="add_horaire_exception.is_error_too_late">
                    <button type="button" class="close" data-dismiss="alert" @click="add_horaire_exception.is_error_too_late = false">
                      <span aria-hidden="true">×</span>
                      <span class="sr-only">Close</span>
                    </button>
                    <strong>Trop tard !</strong> La programmation d'un évènement se fait jusqu'à midi du jour même.
                  </div>
                </transition>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Axios from 'axios';
import DatePicker from 'vue2-datepicker';
import Moment from 'moment';
import Spinner from 'vue-simple-spinner';

import Alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'izitoast/dist/css/iziToast.min.css';

import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

require('vue-style-loader!@/assets/css/app/carte.css');
require('vue-style-loader!@/assets/css/schedule.css');
require('vue-style-loader!@/assets/css/monthly.css');

var func = require('@/assets/js/fonctions.js');
var _ = require('underscore');

export default {

  props: ['userParam', 'currentPage', 'updateCalendar', 'currentPageTime'],

  components: {
    Spinner,
    DatePicker,
  },

  data () {
    return {

      spinner: {
        is_loading: true,
      },

      email_avertissement: "",

      is_timeout_word_rotator_init: undefined,

      // Modification en cours pour afficher le bouton enregistrer / annuler
      is_modification_zone_en_cours: false,

      // Voie en cours de moficiation
      voies_en_cours_modification : new Set(),

      // Création utilisateur
      new_user: {
        datas: {},
        voie_1: {
          date_limite: [],
        },
        voie_2: {
          date_limite: [],
        },

        // Erreur "Cannot use 'in' operator to search for '0' in" lorsque affecté dans new_user.voie_X
        voie_1_heure_reinit: [],
        voie_2_heure_reinit: [],

        zones: {}, // Zone par default
        is_error: false,
        is_success: false,
        is_error_existant: false,
        is_error_heure_reinit: false,
      },

      // Mise à jour d'un utilisateur
      update_user: {
        datas: {},
        is_error: false,
        is_success: false,
        is_error_existant: false,
        is_error_heure_reinit: false,
      },

      // Utilisateur en cours
      user: undefined,

      // Page du toggle par defaut
      current_page: "ZONE",

      // Meteo dans etat général
      meteo: {},

      // Ville
      ville: {
        id: undefined,
        code_postal: "",
        nom: "",
      },

      // Liste utilisateur
      users: [],

      // Etat général
      is_etat_general_ok: true,

      // Timeout lors du changement horaire
      timeout_voies: [],

      heure_levee_soleil_moment: undefined,
      heure_coucher_soleil_moment: undefined,

      // Suvol de la zone
      zone_over: null,

      // Bouton de forcage
      btn_forcage_disabled: [],

      // Nouveau password pour l'utilisateur en cours
      new_pass: null,

      // Nouveau login
      new_login: null,

      // Par defaut : Creation utilisateur
      utilisateur_action: "add_utilisateur",

      // Mon compte
      account: {
        is_error: false,
        is_success: false
      },

      map: null,
      tab_menu_choose: "ZONE",
      is_show_users: false,

      // Outils de dessin
      drawingManager: null,

      // overlay
      overlays: [],

      // Liste des zones avec le calendrier d'affiché
      zones_show: [],

      modal: {
        is_open: false,
        i_z: null,
        i_v: null,
        i_h: null
      },
      remove_horaire: [{
        is_show: false,
        i_z: null,
        i_v: null,
        i_h: null,
        debut: "",
        fin: ""
      },{
        is_show: false,
        i_z: null,
        i_v: null,
        i_h: null,
      }],

      // Problème avec la création du user qui ne met pas
      user_creation_date_voie_1: [],
      user_creation_date_voie_2: [],

      // Liste des zones
      zones: [],

      // Déja dessiné ?
      is_drawed: false,

      // Récupération des logs
      logs: [],

      index_menu: 1,

      // 1er chargement
      is_first_load: true,

      // Zone selectionne
      zone: {
        identifiant: "000000"
      },

      // Zone selectionné temporaire (pour annuler les modifications)
      zone_tmp: {},

      // Horaire de début et de fin (1 pour chaque voies)
      add_horaire: [
        {
          debut: "",
          fin: "",
          is_error: false
        },
        {
          debut: "",
          fin: "",
          is_error: false
        }
      ],

      // Message
      toast: undefined,

      // Horaire de début et de fin (1 pour chaque voies)
      exclure_horaire: [
        {
          debut: "",
          fin: "",
          is_error: false
        },
        {
          debut: "",
          fin: "",
          is_error: false
        }
      ],

      modal_voie_en_cours: 0,

      // Horaire de début et de fin d'exception
      add_horaire_exception:
      {
        evenement_exclusion: "",
        heure_debut_exclusion: "",
        heure_fin_exclusion: "",
        date_exclusion: "",
        is_error: false,
        is_error_date_before_now: false,
        is_error_too_late: false,
      },

      drawOptions: {
        fillColor: '#dc3545', //#f0a340
        strokeWeight: 0,
        fillOpacity: 0.5,
        editable: true,
        draggable: true,
        content: 'Zone'
      }
    }
  },

  created () {

    var this_ = this;

    this.map = null;

    // Centrage de la carte vers le code postal
    this.$parent.$on('centrage_ville', function() {
      this_.centreGoogleMapTo(this_.ville.coords);
    });

    // Check utilisateur connecté
    this.$parent.$emit('updateUser');

    // Message concernant la fermeture de l'onglet
    window.addEventListener("beforeunload", function (event) {
      event.returnValue = "";
    });

    // Redefinition de minimalDialog de la librairie de popup
    Alertify.minimalDialog || Alertify.dialog('minimalDialog',function(){
      return {
        main:function(content){
          this.setContent(content);
        },
        hooks: {
          onclose: function() {

          }
        }
      };
    });

    // Instanciation des différentes modals
    var modals = ["modalTestKo", "modalTestOk", "modalRemoveZone", "modalCrepusculaire", "modalException", "modalDelete", "modalAddHoraire", "modalAddExclusion", "modalStopForcage", "modalToggleForcage"];
    for (var i_modal = 0, length_modal = modals.length; i_modal < length_modal; i_modal++) {
      Alertify.dialog(modals[i_modal],function(){
        return {
          main:function(content){
            this.setContent(content);
          },
          setup:function(){
            return {
              options:{
                basic:false,
                maximizable:false,
                resizable:false,
                padding:false
              }
            };
          },
          settings:{
            selector:undefined
          }
        };
      });
    }

  },

  mounted  () {

    var this_ = this;

    // Chargement
    this.spinner.is_loading = true;

    // Récupération des zones via pooling
    setInterval(() => {
      this_.getZones();
      this_.is_drawed = true;
    }, 10000);

  },

  watch: {

    /*
    * Evenement reçu par le parent lors d'une suppression d'un evenement.
    */
    updateCalendar: function(i_voie) {
      var this_ = this;
      this_.getZones({is_force_refresh_zone: true}, function() {

        this_.openModalException(i_voie);
        this_.$popup({ message: 'Événement supprimé' });

      });
    },

    /*
    * Ouverture de la page
    */
    currentPageTime: function() {
      if (jQuery(document.querySelector("#mainMenu")).hasClass("sidebar-vertical-bottom")) {
        this.toggleNavbar(true);
      }
    },

    /*
    * Changement de page en cours
    */
    currentPage: function(page) {

      // Raz des messages d'erreurs
      this.update_user.is_error_existant = false;
      this.update_user.is_error = false;
      this.update_user.is_error_heure_reinit = false;
      this.account.is_error = false;
      this.account.is_success = false;

      this.current_page = page;

      this.$forceUpdate();

    },

    /*
    * Utilisateur en cours
    */
    userParam: function(user){

      this.user = user;

      // Initialisation de la carte google
      this.initGoogleMap();

      // Récupère les zones
      this.getZones();

      // Uniquement administrateur
      // Récupération des utilisateurs
      if (this.user.is_admin) {
        this.getUtilisateurs();
        this.initDrawingTools();
      }

    },

    /*
    * Changement de menu
    */
    tab_menu_choose: function(val) {

      switch (val) {

        case "ZONE" :

        this.initDrawingTools();

        ;break;

        default:

        // Pour les autres menus on retire les elements pour dessigner
        if (this.drawingManager) {
          this.drawingManager.setMap(null);
          this.drawingManager = null;
        }

      }

    }

  },

  methods : {

    /*
    * Set la zone en cours
    */
    setZones: function(zone) {
      this.zone = zone;
      this.current_page = 'ZONE';
    },

    /*
    * Tester la configuration
    */
    testerConfig: function() {
      if (!this.zone) return;
      Axios.get(func.url_backend + '/api/nodlight/systeme/test/' + this.zone.api_free.user + '/' + this.zone.api_free.apikey).then((response) => {
        if (response.data) {
          Alertify.modalTestOk(document.getElementById('modal-test-ok')).setting('title', 'Test de la configuration');
        } else {
          Alertify.modalTestKo(document.getElementById('modal-test-ko')).setting('title', 'Test de la configuration');
        }
      }).catch( (error) => {
        console.log(error);
      });

    },

    /*
    * Modal permettant d'arret un forcage
    */
    modalStopForcage: function(i_voie) {
      this.modal_voie_en_cours = i_voie;
      Alertify.modalStopForcage(document.getElementById("modal-stop-forcage")).setting('title', "Arrêt du forçage sur la <span class='c-blue'>voie " + (i_voie + 1) + "</span> de la zone <span class='c-blue'>" + this.zone.libelle + "</span>");
    },

    /*
    * Modal permettant le forcage d'une voie
    */
    modalGoForcage: function(i_voie) {
      this.modal_voie_en_cours = i_voie;
      var action = (this.zone.voies[i_voie].is_allume) ?  "extinction" : "allumage";
      Alertify.modalToggleForcage(document.getElementById("modal-toggle-forcage")).setting('title', "Forcer l'" + action + " sur la <span class='c-blue'>voie " + (i_voie + 1) + "</span> de la zone <span class='c-blue'>" + this.zone.libelle + "</span>");
    },

    /*
    * Modal d'exclusion horaire
    */
    modalExclureHoraire: function(i_voie) {
      this.modal_voie_en_cours = i_voie;
      Alertify.modalAddExclusion(document.getElementById("modal-add-exclusion")).setting('title', "Ajout d'une tranche horaire d'exclusion sur la <span class='c-blue'>voie " + (i_voie + 1) + "</span> de la zone <span class='c-blue'>" + this.zone.libelle + "</span>");
    },

    /*
    * Modal pour ajouter un horaire
    */
    modalAddHoraire: function(i_voie) {
      this.modal_voie_en_cours = i_voie;
      Alertify.modalAddHoraire(document.getElementById('modal-add-horaire')).setting('title', "Ajout d'une tranche horaire sur la <span class='c-blue'>voie " + (i_voie + 1) + "</span> de la zone <span class='c-blue'>" + this.zone.libelle + "</span>");
    },

    /*
    * Message de confirmation de suppression
    */
    modalRemoveZone: function() {
      Alertify.modalRemoveZone(document.getElementById("modal-remove-zone")).setting('title', "Suppression de la zone <span class='c-blue'>" + this.zone.libelle + "</span>");
    },

    /*
    * Annule les modifications sur toutes les zones !
    */
    cancelModification: function() {

      this.zone = jQuery.extend(true, {}, this.zone_tmp);

      this.is_modification_zone_en_cours = false;
      this.voies_en_cours_modification.clear();

      this.initCalendar(0);
      this.initCalendar(1);

      this.resetTrancheHoraire(0);
      this.resetTrancheHoraire(1);

      this.resetTrancheHoraireExclusion(0);
      this.resetTrancheHoraireExclusion(1);

      this.$forceUpdate();

    },

    /*
    * Sauvegarde la voie
    */
    saveVoie: function(i_voie) {
      var this_ = this;

      this_.updateZone({zone: this_.zone, i_voie: i_voie}, (is_ok) => {
        if (is_ok) this_.$popup({ message: 'Sauvegardé' });

        this_.zone_tmp = jQuery.extend(true, {}, this_.zone);
        this_.is_modification_zone_en_cours = false;
        this_.voies_en_cours_modification.clear();
      });

      this_.$forceUpdate();

    },

    /*
    * Affichage un message
    */
    showMessage: function(params) {

      iziToast.show(params, this.toast);
      this.toast = document.querySelector('.iziToast');

    },

    /*
    * Supprime une tranche horaire d'exclusion
    */
    removeExclusionHoraire: function(i_voie, i_horaire_exclusion) {

      var this_ = this;

      this_.zone.voies[i_voie].interval_exclusion_allumage.splice(i_horaire_exclusion, 1);

      this_.$popup({ message: 'Horaire supprimé' });

      this_.initCalendar(i_voie);

      this_.is_modification_zone_en_cours = true;
      this_.voies_en_cours_modification.add(i_voie);

    },

    /*
    * Permet d'exclure une tranche horaire d'un crépusculaire
    */
    exclureHoraire: function(i_voie) {

      var this_ = this;
      var debut = this.exclure_horaire[i_voie].debut;
      var fin = this.exclure_horaire[i_voie].fin;

      var debut_moment = Moment(debut, "HH:mm");
      var fin_moment = Moment(fin, "HH:mm");

      // Arrondi les minutes de debut au pas de 5
      var debut_hours = debut_moment.hours();
      var debut_minutes = debut_moment.minutes();
      debut_minutes = this.round5(debut_minutes);
      if (debut_minutes === 60) {
        debut_minutes = "00";
        debut_hours += 1;
      }

      debut = debut_hours + ":" + debut_minutes;
      debut_moment = Moment(debut, "HH:mm");

      // Arrondi les minutes de fin au pas de 5
      var fin_hours = fin_moment.hours();
      var fin_minutes = fin_moment.minutes();
      fin_minutes = this.round5(fin_minutes);
      if (fin_minutes === 60) {
        fin_minutes = "00";
        fin_hours += 1;
      }

      fin = fin_hours + ":" + fin_minutes;
      fin_moment = Moment(fin, "HH:mm");

      if (!debut || !fin) {
        this.$popup({ message: 'La tranche horaire est incorrecte !', delay: 20, backgroundColor: "rgba(234, 109, 100, 0.8)" });
        this.resetTrancheHoraireExclusion(i_voie);
        return;
      }

      if (!debut_moment.isValid() || !fin_moment.isValid()) {
        this.$popup({ message: 'La tranche horaire est incorrecte !', delay: 20, backgroundColor: "rgba(234, 109, 100, 0.8)" });
        this.resetTrancheHoraireExclusion(i_voie);
        return;
      }

      if (debut_moment.valueOf() >= fin_moment.valueOf()) {
        this.$popup({ message: 'La tranche horaire est incorrecte !', delay: 20, backgroundColor: "rgba(234, 109, 100, 0.8)" });
        this.resetTrancheHoraireExclusion(i_voie);
        return;
      }

      this.zone.voies[i_voie].interval_exclusion_allumage.push({'debut': debut_moment.format("HH:mm").valueOf(), 'fin': fin_moment.format("HH:mm").valueOf()});

      var is_ok = this.initCalendar(i_voie);

      Alertify.modalAddExclusion().close();

      this.$popup({ message: 'Plage horaire ajoutée' });

      // Reset
      this.resetTrancheHoraireExclusion(i_voie);

      this.is_modification_zone_en_cours = true;
      this.voies_en_cours_modification.add(i_voie);

      this.$forceUpdate();

    },

    /*
    * Lance / Annule le mode crépusculaire
    */
    toggleCrepusculaire: function(i_voie) {

      // Changement sur le mode crépusculaire
      this.zone.voies[i_voie].is_crepusculaire = !this.zone.voies[i_voie].is_crepusculaire;

      this.initCalendar(i_voie);

      this.is_modification_zone_en_cours = true;
      this.voies_en_cours_modification.add(i_voie);

    },

    /*
    * Stop le forçage d'une zone
    */
    stopForcage: function(i_voie) {

      Alertify.modalStopForcage().close();

      this.$popup({ message: 'Commande envoyée' });

      var libelle_action = "Arrêt du forçage de la zone : " + this.zone.libelle + " - voie " + (i_voie + 1);

      Axios.post(func.url_backend + '/api/nodlight/sites/' + this.user.id_site + '/zones/' + this.zone.id_zone + '/voies/' + i_voie + '/utilisateurs/' + this.user._id + '/action/0').then((response) => {

        this.getZones();

      }).catch( (error) => {
        console.log(error);
      });

    },

    /*
    * Force l'allumage / L'extinction des voies pour une zone
    */
    goForcage: function(i_voie) {

      var this_ = this;

      Alertify.modalToggleForcage().close();

      this.$popup({ message: 'Commande envoyée' });

      Axios.post(func.url_backend + '/api/nodlight/sites/' + this.user.id_site + '/zones/' + this.zone.id_zone + '/voies/' + i_voie + '/utilisateurs/' + this.user._id + '/action/1').then((response) => {

        this.getZones();

      }).catch( (error) => {
        console.log(error);
      });

      this_.$forceUpdate();

    },


    /*
    * Valide la modification utilisateur
    */
    validUpdateUser: function() {

      // Décalage horaire
      var date_gmt = this.update_user.datas.date_validite;
      this.update_user.datas.date_validite = new Date(Moment.utc(this.update_user.datas.date_validite).add(Math.abs(new Date().getTimezoneOffset()), 'minutes').set('hour', 12).valueOf());

      if (!this.update_user.datas.login || !this.update_user.datas.pass || !this.update_user.datas.description || !this.update_user.datas.date_validite) {
        this.update_user.is_error = true;
        return;
      }

      // Check si les informations concernant l'heure de reinitialisation sont corrects pour la voie 1 et 2
      var keys = Object.keys(this.update_user.datas.zones);
      for(var i_zone_user = 0, length_zone_user = keys.length; i_zone_user < length_zone_user; i_zone_user++) {
        let zone = this.update_user.datas.zones[keys[i_zone_user]];

        if (zone.voie_1.heure_reinit > 6 || zone.voie_2.heure_reinit > 6) {
          this.update_user.is_error_heure_reinit = true;
          return;
        }

        // Ajout de 12h
        if (zone.voie_1.date_limite) {
          zone.voie_1.date_limite = Moment(zone.voie_1.date_limite).add(12, 'hours');
        }

        if (zone.voie_2.date_limite) {
          zone.voie_2.date_limite = Moment(zone.voie_2.date_limite).add(12, 'hours');
        }

      }

      // On retourne sur l'ajout d'un utilisateur
      this.utilisateur_action = "add_utilisateur";

      if (this.update_user.datas.new_pass) {
        this.update_user.datas.pass = this.update_user.datas.new_pass;
      }

      this.initMessage();
      this.updateUser(this.update_user.datas);

    },

    /*
    * Annule la mise à jour utilisateur
    */
    cancelUpdateUser: function() {
      this.utilisateur_action = "add_utilisateur";
      this.getUtilisateurs();
    },

    /*
    * Initialise les messages
    */
    initMessage: function() {
      this.update_user.is_error = false;
      this.update_user.is_error_existant = false;

      this.new_user.is_error = false;
      this.new_user.is_error_existant = false;
    },

    /*
    * Mise à jour de l'utilisateur
    */
    editUser: function(i_user) {
      this.initMessage();
      this.utilisateur_action = 'update_utilisateur';
      this.update_user.datas = Object.assign({}, this.users[i_user]);

      // Affectation des zones
      for (var i_zones = 0, length_zones = this.zones.length; i_zones < length_zones; i_zones++){

        // Lorsqu'il ne trouve pas les zones
        if (!this.update_user.datas.zones[this.zones[i_zones].id_zone]) {
          this.update_user.datas.zones[this.zones[i_zones].id_zone] = {
            voie_1: {is_show: false},
            voie_2: {is_show: false}
          };
        }

      }

    },

    /*
    * Récupération des logs pour une zone
    */
    toggleLogsZone: function() {

      this.index_menu = 2;

      Axios.get(func.url_backend + "/api/nodlight/logs/zones/"+ this.zone.id_zone).then((response) => {

        if (!response.data.ok) return;

        this.zone.logs = response.data.obj;

        this.$forceUpdate();

      }).catch( (error) => {
        console.log(error);
      });
    },

    /*
    * Active / Desactive les voies à affecter a l'utilisateur
    */
    toggleCheckedZone: function(zone, i_voie, id, current_action_user) {

      // Voie choisie ? On lui affecte la zone avec la voie correspondante
      if (document.getElementById(id).checked) {
        this[current_action_user].datas.zones[zone.id_zone]["voie_" + i_voie].is_show = true;
      } else {
        this[current_action_user].datas.zones[zone.id_zone]["voie_" + i_voie].is_show = false;
      }

    },

    /*
    * Focus la carte sur l'emplacement de la 1ere zone
    */
    focusToZone: function(){

      try {

        if (this.zones.length === 0 || this.is_drawed)  return;

        this.map.setZoom(15);

        switch (this.zones[0].type) {
          case "circle":
          this.map.panTo(this.zones[0].coords.center);
          ;break;

          case "rectangle":
          this.map.panTo(this.zones[0].coords.bounds);
          ;break;

          default:
          this.map.panTo(this.zones[0].coords[0]);
        }

      } catch (e) {
        // Pas d'internet
      }

    },

    /*
    * Initialisation des outils de dessin
    */
    initDrawingTools: function() {

      try {

        var this_ = this;

        if (this_.drawingManager) return;

        // Initialisation des outils de création de zones
        this_.drawingManager = new google.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['circle', 'polygon', 'rectangle']
          },
          polygonOptions: this_.polyOptions,
          markerOptions: this_.polyOptions,
          circleOptions: this_.polyOptions,
          rectangleOptions: this_.polyOptions
        });

        // Annule la création d'une zone au clique droit
        google.maps.event.addListener(this_.map, "rightclick", function(){
          this_.initDrawingTools();
        });

        // Ajout de l'evenement
        google.maps.event.addListener(this_.drawingManager, 'overlaycomplete', function(event) {

          // Stop de dessiner
          this_.drawingManager.setDrawingMode(null);

          var coords = [];
          var type = event.type;

          switch (event.type) {

            case "polygon":
            var lat_lng = event.overlay.getPath().getArray();
            for (var i_lat_lng = 0, length_lat_lng = lat_lng.length; i_lat_lng < length_lat_lng; i_lat_lng++) {
              coords[i_lat_lng] = {lat: lat_lng[i_lat_lng].lat(), lng: lat_lng[i_lat_lng].lng()};
            }
            ;break;

            case "rectangle":
            coords = {
              bounds: event.overlay.getBounds()
            }
            ;break;

            case "circle":
            coords = {
              center: event.overlay.getCenter(),
              radius: event.overlay.getRadius()
            };
            ;break;

          }

          event.overlay.setMap(null);

          this_.saveZone({'libelle': 'Zone', 'is_edit' : false, 'coords': coords, 'type': type, 'is_erreur_reception': true});

        });

        this_.drawingManager.setMap(this_.map);

      } catch (e) {
        // Pas d'internet ?
      }

    },

    /*
    * Met à jour le status de l'utilisateur (actif ou non)
    */
    updateStatus: function(i_user, id) {

      this.users[i_user].is_actif = document.getElementById(id).checked;

      this.updateUser(this.users[i_user]);

    },

    /*
    * Supprime un utilisateur
    */
    removeUser: function(i_user) {
      Axios.delete(func.url_backend + '/api/nodlight/utilisateurs/' + this.users[i_user]._id).then((response) => {
        this.getUtilisateurs();
      }).catch( (error) => {
        console.log(error);
      });
    },

    /*
    * Ajoute un utilisateur
    */
    addUser: function() {

      // Décalage horaire
      var date_gmt = this.new_user.datas.date_validite;
      this.new_user.datas.date_validite = new Date(Moment.utc(this.new_user.datas.date_validite).add(Math.abs(new Date().getTimezoneOffset()), 'minutes').set('hour', 12).valueOf());

      if (!this.new_user.datas.login || !this.new_user.datas.pass || !this.new_user.datas.description || !this.new_user.datas.date_validite) {
        this.new_user.is_error = true;
        return;
      }

      // Check si les informations concernant l'heure de reinitialisation sont corrects pour la voie 1 et 2
      var keys = Object.keys(this.new_user.zones);
      for(var i_zone_user = 0, length_zone_user = keys.length; i_zone_user < length_zone_user; i_zone_user++) {
        let zone = this.new_user.datas.zones[keys[i_zone_user]];

        if (zone.voie_1.heure_reinit > 6 || zone.voie_2.heure_reinit > 6) {
          this.new_user.is_error_heure_reinit = true;
          return;
        }
      }

      // Set les dates de limite
      var keys = Object.keys(this.new_user.zones);
      for(var i_zone_user = 0, length_zone_user = keys.length; i_zone_user < length_zone_user; i_zone_user++) {
        this.new_user.datas.zones[keys[i_zone_user]].voie_1.date_limite = this.new_user.voie_1.date_limite[i_zone_user];
        this.new_user.datas.zones[keys[i_zone_user]].voie_2.date_limite = this.new_user.voie_2.date_limite[i_zone_user];
      }

      Axios.post(func.url_backend + '/api/nodlight/utilisateurs', {id_a: this.user._id, u: JSON.stringify(this.new_user.datas)}).then((response) => {

        if (response.data.ok) {

          this.$popup({ message: 'Utilisateur créé', delay: 20});

          this.new_user.is_error_existant = false;
          this.new_user.is_error = false;
          this.new_user.is_error_heure_reinit = false;

          this.new_user.datas = {};
          this.new_user.datas.zones = JSON.parse(JSON.stringify(this.new_user.zones));
          this.new_user.voie_1 = {date_limite: []};
          this.new_user.voie_2 = {date_limite: []};

          this.initZoneAffectation();

          this.getUtilisateurs();

        } else {
          this.new_user.is_error = false;
          this.new_user.is_error_heure_reinit = false;
          this.new_user.is_error_existant = true;
        }

      }).catch( (error) => {
        console.log(error);

        this.new_user.is_error_heure_reinit = false;
        this.new_user.is_error_existant = false;
        this.new_user.is_error = true;

      });

    },

    /*
    * Met à jour le compte actuel
    */
    majCompte: function(){

      var this_ = this;

      if (this_.new_pass) this_.user.pass = this_.new_pass;

      this_.updateUser(this_.user);

    },

    /*
    * Retourne les utilisateurs affectés à l'administrateur
    */
    getUtilisateurs: function() {
      Axios.get(func.url_backend + '/api/nodlight/sites/' + this.user.id_site + '/utilisateurs').then((response) => {

        if (response.data.ok) {
          this.users = response.data.obj;
        }

      }).catch( (error) => {
        console.log(error);
      });
    },

    /*
    * Met à jour un utilisateur
    */
    updateUser: function(utilisateur, callback) {

      Axios.put(func.url_backend + '/api/nodlight/utilisateurs/' + utilisateur._id, {u: JSON.stringify(utilisateur)}).then((response) => {

        if (this.current_page == 'UTILISATEUR') {
          // Page de gestion des utilisateurs
          this.getUtilisateurs();

          this.update_user.is_error_existant = false;
          this.update_user.is_error = false;
          this.update_user.is_error_heure_reinit = false;

        } else {
          // Page de configuration du compte
          this.$parent.$emit('updateUser', response.data.obj);

        }

        this.$popup({ message: 'Sauvegardé', delay: 20});

        if (callback) return callback();

      }).catch( (error) => {
        console.log(error);
      });

    },

    /*
    * Supprime une tranche horaire
    */
    removeHoraire: function(i_voie, i_horaire){

      var this_ = this;

      this.modal.is_open = false;

      this.zone.voies[i_voie].interval_horaire_allumage.splice(i_horaire, 1);

      this.remove_horaire[i_voie].is_show = false;

      this.initCalendar(i_voie);

      Alertify.modalDelete().close();

      this.$popup({ message: 'Effectué' });

      this.is_modification_zone_en_cours = true;
      this.voies_en_cours_modification.add(i_voie);

    },

    /*
    * Réinitialisation du formulaire
    */
    initFormException: function() {
      this.add_horaire_exception.evenement_exclusion = "";
      this.add_horaire_exception.date_exclusion = "";
      this.add_horaire_exception.heure_debut_exclusion = "";
      this.add_horaire_exception.heure_fin_exclusion = "";
      this.add_horaire_exception.is_error = false;
      this.add_horaire_exception.is_error_date_before_now = false;
      this.add_horaire_exception.is_error_too_late = false;
    },

    /*
    * Ouvre un calendrier avec les exceptions
    */
    openModalException: function(i_voie) {

      this.initFormException();

      this.modal.is_open = true;
      this.modal.type = "exception";
      this.modal.i_v = i_voie;

      var params = [];

      for (var i_h_exception = 0, length_horaire = this.zone.voies[i_voie].dates_exclusion.length; i_h_exception < length_horaire; i_h_exception++) {
        let date_exception = this.zone.voies[i_voie].dates_exclusion[i_h_exception];

        let val = {
          "id": this.ville.id + "-" + this.zone.id_zone + "-" + i_voie + "-" + i_h_exception,
          "name": "<small class='fs-12 float-left'>" + date_exception.evenement_exclusion + "</small> <small class='float-right'><small class='fs-10'>" + date_exception.heure_debut_exclusion + "</small> - <small class='fs-10'>" + date_exception.heure_fin_exclusion + "</small></small>",
          "startdate": date_exception.date_exclusion.substr(0, 10),
          "enddate": date_exception.date_exclusion.substr(0, 10),
          "starttime": date_exception.heure_debut_exclusion,
          "endtime": date_exception.heure_fin_exclusion,
        };

        // Gestion de l'allumage de l'evenement ou non
        if (date_exception.is_allumage) {
          val.color = "#8ab933";
        } else {
          val.color = "rgba(0, 0, 0, 0.6)";
        }

        params.push(val);
      }

      // Fix bug : Regénère le calendrier, fait sauter les mois
      var new_id = Date.now();
      $('#mycalendar').empty().replaceWith('<div class="monthly" id="cal_' + new_id + '"></div>');

      setTimeout(() => {
        $('#cal_' + new_id).monthly({
          mode: 'event',
          weekStart: 'Mon',
          dataType: 'json',
          events: {
            "monthly": params
          }
        });

      }, 500);

      Alertify.modalException(document.getElementById("modal-exception")).setting('title', "Ajouter un événement");

    },

    /*
    * Ajoute des horaires d'exceptions
    */
    addHoraireException(i_voie) {

      var this_ = this;
      var debut = this.add_horaire_exception.heure_debut_exclusion;
      var fin = this.add_horaire_exception.heure_fin_exclusion;

      // Manque informations
      if (!debut || !fin || !this.add_horaire_exception.evenement_exclusion || !this.add_horaire_exception.date_exclusion) {
        this.add_horaire_exception.is_error = true;
        return;
      }

      var debut_split = debut.split(":");
      var fin_split = fin.split(":");

      var debut_moment = Moment(this.add_horaire_exception.date_exclusion);
      debut_moment.hours(debut_split[0]).minutes(debut_split[1]);

      var fin_moment = Moment(this.add_horaire_exception.date_exclusion);
      fin_moment.hours(fin_split[0]).minutes(fin_split[1]);

      var now_moment = Moment();

      // Date valide ?
      if (!debut_moment.isValid() || !fin_moment.isValid()) {
        this.add_horaire[i_voie].is_error = true;
        return;
      }

      // Date de fin avant date de début
      if (fin_moment.isBefore(debut_moment)) {
        this.add_horaire_exception.is_error = true;
        return;
      }

      // Evenement avant la date d'aujourdhui
      if (debut_moment.isBefore(now_moment)) {
        this.add_horaire_exception.is_error_date_before_now = true;
        return;
      }

      // Après 12h on ne prend plus les evenements à ajouter pour les evenements sur le jour même
      if (now_moment.format("HH").valueOf() >= 12 && debut_moment.format("YYYYMMDD").valueOf() == Moment().format("YYYYMMDD").valueOf()) {
        this.add_horaire_exception.is_error_too_late = true;
        return;
      }

      // Avant midi et si l'evenement à lieu avant midi
      if (now_moment.format("HH").valueOf() < 12 && debut_moment.format("YYYYMMDD").valueOf() == Moment().format("YYYYMMDD").valueOf() && debut_moment.format("HH").valueOf() < 12) {
        this.add_horaire_exception.is_error_too_late = true;
        return;
      }

      // Ajout des horaires
      this.zone.voies[i_voie].dates_exclusion.push({
        'evenement_exclusion': this.add_horaire_exception.evenement_exclusion,
        'date_exclusion': Moment(this.add_horaire_exception.date_exclusion).format("YYYY-MM-DD").valueOf(),
        'heure_debut_exclusion': Moment(debut, "HH:mm").format("HH:mm").valueOf(),
        'heure_fin_exclusion': Moment(fin, "HH:mm").format("HH:mm").valueOf(),
        'is_allumage': this.add_horaire_exception.is_allumage,
      });

      this.$popup({ message: 'Événement ajouté' });

      // Mis à jour de la zone
      this_.updateZone({zone: this_.zone});

      // On rappel l'ouverture de la modal pour raffraichir les données
      this.openModalException(i_voie);

    },

    /*
    * Arrondi au pas de 5
    */
    round5: function(x) {
      return Math.ceil(x/5)*5;
    },

    /*
    * Reset la tranche horaire
    */
    resetTrancheHoraire: function(i_voie) {
      this.add_horaire[i_voie] = {
        debut: "",
        fin: "",
        is_error: false
      }
      this.$forceUpdate();
    },

    /*
    * Reset la tranche horaire
    */
    resetTrancheHoraireExclusion: function(i_voie) {
      this.exclure_horaire[i_voie] = {
        debut: "",
        fin: "",
        is_error: false
      }
      this.$forceUpdate();
    },

    /*
    * Ajoute les horaires de debut et de fin d'Allumage
    */
    addHoraire: function(i_voie) {

      var this_ = this;
      var debut = this.add_horaire[i_voie].debut;
      var fin = this.add_horaire[i_voie].fin;

      // Date de renseigné ?
      if (!debut || !fin) {
        this.$popup({ message: 'La tranche horaire est incorrecte !', delay: 20, backgroundColor: "rgba(234, 109, 100, 0.8)" });
        this.resetTrancheHoraire(i_voie);
        return;
      }

      var debut_moment = Moment(debut, "HH:mm");
      var fin_moment = Moment(fin, "HH:mm");

      // Arrondi les minutes de debut au pas de 5
      var debut_hours = debut_moment.hours();
      var debut_minutes = debut_moment.minutes();
      debut_minutes = this.round5(debut_minutes);
      if (debut_minutes === 60) {
        debut_minutes = "00";
        debut_hours += 1;
      }

      debut = debut_hours + ":" + debut_minutes;
      debut_moment = Moment(debut, "HH:mm");

      // Arrondi les minutes de fin au pas de 5
      var fin_hours = fin_moment.hours();
      var fin_minutes = fin_moment.minutes();
      fin_minutes = this.round5(fin_minutes);
      if (fin_minutes === 60) {
        fin_minutes = "00";
        fin_hours += 1;
      }

      fin = fin_hours + ":" + fin_minutes;
      fin_moment = Moment(fin, "HH:mm");

      if (debut_moment.valueOf() >= fin_moment.valueOf()) {
        this.$popup({ message: 'La tranche horaire est incorrecte !', delay: 20, backgroundColor: "rgba(234, 109, 100, 0.8)" });
        this.resetTrancheHoraire(i_voie);
        return;
      }

      this.zone.voies[i_voie].interval_horaire_allumage.push({'debut': debut_moment.format("HH:mm").valueOf(), 'fin': fin_moment.format("HH:mm").valueOf()});

      this.initCalendar(i_voie);

      this.$popup({ message: 'Plage horaire ajoutée' });

      this.is_modification_zone_en_cours = true;
      this.voies_en_cours_modification.add(i_voie);

      Alertify.modalAddHoraire().close();

      // Reset
      this.resetTrancheHoraire(i_voie);

    },

    /*
    * Supprime les variables superflu avant envoi au back
    */
    formatZoneBeforeSend: function(zone) {
      var zone_tmp = Object.assign({}, zone);
      delete zone_tmp.is_edit;
      delete zone_tmp.overlay;
      delete zone_tmp.schedule_0;
      delete zone_tmp.schedule_1;
      return zone_tmp;
    },

    /*
    * Met à jour la zone
    */
    updateZone: function(params, callback){

      var this_ = this;

      var zone = this_.formatZoneBeforeSend(params.zone);

      if (!zone.identifiant) {
        zone.identifiant = "000000";
      }

      Axios.put(func.url_backend + '/api/nodlight/sites/' + this_.user.id_site + '/zones/' + zone.id_zone + '/voies', {z: JSON.stringify(zone), v: JSON.stringify(this.voies_en_cours_modification)}).then((response) => {

        if (callback) return callback(true);

      }).catch( (error) => {
        console.log(error);

        if (callback) return callback(false);

      });

    },

    /*
    * Enregistre la zone
    */
    saveZone: function(zone){

      this.current_page = 'ZONE';

      var zone_without = this.formatZoneBeforeSend(zone);

      if (!zone_without.identifiant) {
        zone_without.identifiant = "000000";
      }

      Axios.post(func.url_backend + '/api/nodlight/sites/' + this.user.id_site + '/zones', {z: JSON.stringify(zone_without)}).then((response) => {

        if (response.data.ok) {

          this.getZones();

          // On récupère la zone en cours et on ouvre l'onglet
          this.zone = response.data.obj;
          this.index_menu = 3;
          this.toggleNavbar(true);

          // this.drawZones(true);
          // this.zones = response.data.obj.zones;
          // this.drawZones();
        }

      }).catch( (error) => {
        console.log(error);
      });
    },

    /*
    * validation de l'edition de la zone
    */
    validZone: function() {
      this.updateZone({zone: this.zone}, (is_ok) => {
        if (is_ok) this.$popup({ message: 'Sauvegardé' });
      });
      this.zone.is_edit = false;
      this.$forceUpdate();
    },

    /*
    * Edition de la zone
    */
    editZone: function() {
      this.zone.is_edit = true;
      this.$forceUpdate();
    },

    /*
    * Evenement lors du clic sur la carte
    */
    evtClickMap: function(event) {

      this.initCalendar(0);
      this.initCalendar(1);

      this.current_page = "ZONE";
      if (jQuery("#mainMenu.sidebar-vertical").css("left") != "0px") {
        this.toggleNavbar();
      }

      if (!this.is_timeout_word_rotator_init) {
        this.is_timeout_word_rotator_init = setTimeout(() => {
          func.wrotate();
        });
      }

    },

    /*
    * Réinitialisation des zones d'affectation
    */
    initZoneAffectation: function() {

      this.new_user.datas.zones = JSON.parse(JSON.stringify(this.new_user.zones));

    },

    /*
    * Supprime tout les marqueurs
    */
    clearGoogleMap: function() {
      while(this.overlays.length) {
        this.overlays.pop().setMap(null);
      }
      this.overlays.length = [];
    },

    /*
    * Lors de changement des elements sur la carte, on affiche les infos de l'élément
    */
    initEtatOnChangeElementMap: function(zone) {
      this.cancelModification();
      this.zone = zone;
      this.zone_tmp = jQuery.extend(true, {}, zone);
      this.zone.is_edit = false;
      this.$parent.$emit('updateCurrentPage', "ZONE");
      this.index_menu = 1;
      this.toggleNavbar(true);
    },

    /*
    * Dessine les zones sur la carte
    */
    drawZones: function(is_no_redraw){

      try {

        var this_ = this;

        // Reinitialisation si deja present (en cas d'ajout)
        this.clearGoogleMap();

        // Evenement sur la touche "Suppr"
        document.addEventListener('keyup', function(event) {
          // Delete
          if (event && event.keyCode === 46) {
            this_.modalRemoveZone();
          }
        });

        // 2 fois la même boucle car supprime toujours le 1er sur la carte (??!)
        for (var i_zone = 0, length_zone = this.zones.length; i_zone < length_zone; i_zone++) {

          // On en profite pour initialiser les zones du nouvel utilisateur
          let zone = this.zones[i_zone];
          this.new_user.zones[zone.id_zone] = {
            "voie_1": {
              is_show: false,
              date_limite: ""
            },
            "voie_2": {
              is_show: false,
              date_limite: ""
            }
          };

        }

        if (is_no_redraw) return;

        var current_timestamp = Moment().valueOf();

        for (var i_zone = 0, length_zone = this.zones.length; i_zone < length_zone; i_zone++) {

          switch (this.zones[i_zone].type) {

            case "polygon":

            var option_draw_surcharge = Object.assign({}, this.drawOptions);

            // Pas possible d'editer, bouffe trop de pers avec l'event "set_at"
            option_draw_surcharge.editable = false;
            var option = JSON.parse(JSON.stringify(option_draw_surcharge));
            option.paths = this.zones[i_zone].coords;

            var polygon = new google.maps.Polygon(option);

            this.overlays.push(polygon);

            polygon.setMap(this.map);

            // Closure
            (function(zone) {

              polygon.addListener('dragend', (event) => {

                this_.initEtatOnChangeElementMap(zone);
                this_.dragend(zone);

              });

              // Zoom sur la zone a modifier
              polygon.addListener('click', (event) => {

                this_.initEtatOnChangeElementMap(zone);
                this_.evtClickMap(event);

              });

              // Survol de la zone
              polygon.addListener('mouseover', (event) => {
                this_.zone_over = zone;
              });

              polygon.addListener('mouseout', (event) => {
                this_.zone_over = null;
              });

            })(this.zones[i_zone]);

            this.zones[i_zone].overlay = polygon;

            ;break;

            case "rectangle":

            var option = JSON.parse(JSON.stringify(this.drawOptions));
            option.bounds = this.zones[i_zone].coords.bounds;

            var rectangle = new google.maps.Rectangle(option);
            this.overlays.push(rectangle);

            rectangle.setMap(this.map);

            // Closure
            (function(zone) {

              rectangle.addListener('dragend', (event) => {

                this_.initEtatOnChangeElementMap(zone);
                this_.dragend(zone);

              });

              rectangle.addListener('bounds_changed', (event) => {
                this_.dragend(zone);
              });

              // Zoom sur la zone a modifier
              rectangle.addListener('click', (event) => {

                this_.initEtatOnChangeElementMap(zone);
                this_.evtClickMap(event);

              });

              // Survol de la zone
              rectangle.addListener('mouseover', (event) => {
                this_.zone_over = zone;
              });

              rectangle.addListener('mouseout', (event) => {
                this_.zone_over = null;
              });

            })(this.zones[i_zone]);

            this.zones[i_zone].overlay = rectangle;

            ;break;

            case "circle":

            var option = JSON.parse(JSON.stringify(this.drawOptions));
            option.center = this.zones[i_zone].coords.center;
            option.radius = this.zones[i_zone].coords.radius;

            var circle = new google.maps.Circle(option);
            this.overlays.push(circle);

            circle.setMap(this.map);

            // Closure
            (function(zone) {

              circle.addListener('dragend', (event) => {

                this_.initEtatOnChangeElementMap(zone);
                this_.dragend(zone);

              });

              circle.addListener('radius_changed', (event) => {

                this_.initEtatOnChangeElementMap(zone);
                this_.dragend(zone);

              });

              // Zoom sur la zone a modifier
              circle.addListener('click', (event) => {

                this_.initEtatOnChangeElementMap(zone);
                this_.evtClickMap(event);

              });

              // Survol de la zone
              circle.addListener('mouseover', (event) => {
                this_.zone_over = zone;
              });

              circle.addListener('mouseout', (event) => {
                this_.zone_over = null;
              });

            })(this.zones[i_zone]);

            this.zones[i_zone].overlay = circle;

            ;break;

          }

          // Zone en erreur
          if (this.zones[i_zone].is_erreur_reception) {
            this.zones[i_zone].overlay.set('fillColor', '#dc3545');
            this.zones[i_zone].overlay.set('fillOpacity', '0.5');
            continue;
          }

          // Allumage forcé sur les 2 voies
          if (this.zones[i_zone].voies[0].is_allume && this.zones[i_zone].voies[1].is_allume) {
            this.zones[i_zone].overlay.set('fillColor', '#8ab933');
            this.zones[i_zone].overlay.set('fillOpacity', '0.8');
            continue;
          }

          // Allumage force sur la voie 1 mais pas sur la voie 2 OU dans le cas allumage force sur voie 1 et rien sur la voie 2
          if (this.zones[i_zone].voies[0].is_allume_actif && this.zones[i_zone].voies[0].is_allume
            && this.zones[i_zone].voies[1].is_allume_actif &&  !this.zones[i_zone].voies[1].is_allume
            || (this.zones[i_zone].voies[0].is_allume_actif && this.zones[i_zone].voies[0].is_allume && !this.zones[i_zone].voies[1].is_allume_actif)
          ) {
            this.zones[i_zone].overlay.set('fillColor', '#8ab933');
            this.zones[i_zone].overlay.set('fillOpacity', '0.5');
            continue;
          }

          // Allumage force sur la voie 2 mais pas sur la voie 1
          if (this.zones[i_zone].voies[0].is_allume_actif && !this.zones[i_zone].voies[0].is_allume
            && this.zones[i_zone].voies[1].is_allume_actif && this.zones[i_zone].voies[1].is_allume
            || (this.zones[i_zone].voies[1].is_allume_actif && this.zones[i_zone].voies[1].is_allume && !this.zones[i_zone].voies[0].is_allume_actif)
          ) {
            this.zones[i_zone].overlay.set('fillColor', '#8ab933');
            this.zones[i_zone].overlay.set('fillOpacity', '0.5');
            continue;
          }

          if (this.zones[i_zone].voies[0].is_allume || this.zones[i_zone].voies[1].is_allume) {
            this.zones[i_zone].overlay.set('fillColor', '#8ab933');
            this.zones[i_zone].overlay.set('fillOpacity', '0.5');
            continue;
          }

          // Allume les zones suivant les tranches horaires d'allumage
          // Uniquement lorsqu'il n'y a pas de forçage de la voie
          if (!this.zones[i_zone].voies[0].is_allume_actif) {
            for (var i_horaire = 0, length_horaire = this.zones[i_zone].voies[0].interval_horaire_allumage.length; i_horaire < length_horaire; i_horaire++) {
              var horaire = this.zones[i_zone].voies[0].interval_horaire_allumage[i_horaire];

              if (current_timestamp > Moment(horaire.debut, "HH:mm").valueOf() && current_timestamp < Moment(horaire.fin, "HH:mm").valueOf()) {
                this.zones[i_zone].overlay.set('fillColor', '#8ab933');
                this.zones[i_zone].overlay.set('fillOpacity', '0.5');
              }

            }
          }

          if (!this.zones[i_zone].voies[1].is_allume_actif) {
            for (var i_horaire = 0, length_horaire = this.zones[i_zone].voies[1].interval_horaire_allumage.length; i_horaire < length_horaire; i_horaire++) {
              var horaire = this.zones[i_zone].voies[1].interval_horaire_allumage[i_horaire];

              if (current_timestamp > Moment(horaire.debut, "HH:mm").valueOf() && current_timestamp < Moment(horaire.fin, "HH:mm").valueOf()) {
                this.zones[i_zone].overlay.set('fillColor', '#8ab933');
                this.zones[i_zone].overlay.set('fillOpacity', '0.5');
              }
            }
          }

          this.zones[i_zone].overlay.set('fillColor', '#000000');
          this.zones[i_zone].overlay.set('fillOpacity', '0.5');

        }

      } catch (e) {
        // Pas d'internet
      }

    },

    /*
    * Lors du drop
    */
    dragend: function(zone) {
      var coords = [];
      var type = zone.type;

      switch (zone.type) {

        case "polygon":
        var lat_lng = zone.overlay.getPath().getArray();
        for (var i_lat_lng = 0, length_lat_lng = lat_lng.length; i_lat_lng < length_lat_lng; i_lat_lng++) {
          coords[i_lat_lng] = {lat: lat_lng[i_lat_lng].lat(), lng: lat_lng[i_lat_lng].lng()};
        }
        ;break;

        case "rectangle":
        coords = {
          bounds: zone.overlay.getBounds()
        }
        ;break;

        case "circle":
        coords = {
          center: zone.overlay.getCenter(),
          radius: zone.overlay.getRadius()
        };
        ;break;

      }

      zone.coords = coords;

      this.updateZone({zone: zone});

    },

    /*
    * Retourne les zones de l'administrateur
    */
    getZones: function(params, callback) {
      var this_ = this;

      if (!this_.user) return;

      Axios.get(func.url_backend + '/api/nodlight/sites/' + this_.user.id_site + '/zones').then((response) => {

        // Récupération des infos
        this_.ville.code_postal = response.data.obj.code_postal;
        this_.ville.nom = response.data.obj.ville;
        this_.ville.id = response.data.obj._id;
        this_.ville.coords = response.data.obj.coords_ville;
        this_.meteo = response.data.obj.meteo;

        // Récupération du lever / couche de soleil
        this_.heure_levee_soleil_moment = Moment(this_.meteo.heure_levee_soleil, "HH:mm");
        this_.heure_coucher_soleil_moment = Moment(this_.meteo.heure_coucher_soleil, "HH:mm");

        // R2cupération des logs
        this_.logs = response.data.obj.logs;

        // Arrondi les minutes de debut au pas de 5
        var levee_hours = this_.heure_levee_soleil_moment.hours();
        var levee_minutes = this_.heure_levee_soleil_moment.minutes();
        levee_minutes = this.round5(levee_minutes);
        if (levee_minutes === 60) {
          levee_minutes = "00";
          levee_hours += 1;
        }

        this_.heure_levee_soleil_moment = Moment(levee_hours + ":" + levee_minutes, "HH:mm");

        // Arrondi les minutes de fin au pas de 5
        var coucher_hours = this_.heure_coucher_soleil_moment.hours();
        var coucher_minutes = this_.heure_coucher_soleil_moment.minutes();
        coucher_minutes = this.round5(coucher_minutes);
        if (coucher_minutes === 60) {
          coucher_minutes = "00";
          coucher_hours += 1;
        }

        this_.heure_coucher_soleil_moment = Moment(coucher_hours + ":" + coucher_minutes, "HH:mm");

        this_.zones = response.data.obj.zones;

        this_.$parent.$emit('setVille', this_.ville);

        this_.drawZones();

        this_.initZoneAffectation();


        // Initialisation des valeurs par default
        for (var i_zone = 0, length_zone = this_.zones.length; i_zone < length_zone; i_zone++) {

          let zone = this_.zones[i_zone];

          // On check si une zone est est anormal
          if (zone.date_ouverture_porte || zone.is_erreur_reception) {
            this_.is_etat_general_ok = false;
          }
        }

        this_.spinner.is_loading = false;

        // Forçage des infos de la zone en cours si pas de modification en cours et pas sur les logs
        if (this_.zone && !this.is_modification_zone_en_cours && this.index_menu !== 2) {
          var zone = _.findWhere(this.zones, {id_zone: this.zone.id_zone});
          if (zone) this.zone.voies = zone.voies;
        }

        // Pas de zone ? On prend le 1er
        if (this_.is_first_load && this_.zones.length > 0) {
          this_.zone = this_.zones[0];
          this_.zone_tmp = this.zones[0];
          this_.focusToZone();
          this_.initCalendar(0);
          this_.initCalendar(1);
        }

        this_.is_first_load = false;

        if (callback) return callback();

      }).catch( (error) => {
        console.log(error);
      });
    },

    /*
    * Initialisation du calendrier
    */
    initCalendar: function(i_voie) {

      var this_ = this;

      setTimeout(() => {

        var schedule = [];

        // On va vérifier si on est en crepusculaire ou
        var is_crepusculaire = this_.zone.voies[i_voie].is_crepusculaire;

        if (is_crepusculaire) {

          // Crépusculaire
          var is_exception_debut_journee = false;
          var is_exception_fin_journee = false;
          var tab_horaires_exclusion = [];

          // On parcours les horaires d'exception
          for (var i_horaire = 0, length_horaire = this_.zone.voies[i_voie].interval_exclusion_allumage.length; i_horaire < length_horaire; i_horaire++){

            var horaire_exception_debut_moment = Moment(this_.zone.voies[i_voie].interval_exclusion_allumage[i_horaire].debut, "HH:mm");
            var horaire_exception_fin_moment = Moment(this_.zone.voies[i_voie].interval_exclusion_allumage[i_horaire].fin, "HH:mm");

            // Exception comprise entre 0h00 et heure du lever de soleil
            if (horaire_exception_debut_moment.isBefore(this_.heure_levee_soleil_moment)
            && horaire_exception_fin_moment.isBefore(this_.heure_levee_soleil_moment)) {

              // Deja une exception en début de journée ? -> KO
              if (is_exception_debut_journee) {
                this_.resetTrancheHoraireExclusion(i_voie);
                this_.exclure_horaire[i_voie].is_error = true;
                continue;
              }

              is_exception_debut_journee = true;

              if (horaire_exception_debut_moment.isAfter(Moment("00:00", "HH:mm"))) {
                tab_horaires_exclusion.push(["00:00", horaire_exception_debut_moment.format("HH:mm").valueOf()]);
              }

              tab_horaires_exclusion.push([horaire_exception_fin_moment.format("HH:mm").valueOf(), this_.heure_levee_soleil_moment.format("HH:mm").valueOf()]);

            }

            // Exception à cheval sur l'heure de levée
            if (horaire_exception_debut_moment.isBefore(this_.heure_levee_soleil_moment)
            && horaire_exception_fin_moment.isAfter(this_.heure_levee_soleil_moment)) {

              // Deja une exception en début de journée ? -> KO
              if (is_exception_debut_journee) {
                this_.resetTrancheHoraireExclusion(i_voie);
                this_.exclure_horaire[i_voie].is_error = true;
                continue;
              }

              is_exception_debut_journee = true;

              tab_horaires_exclusion.push(["00:00", horaire_exception_debut_moment.format("HH:mm").valueOf()]);

            }

            // Exception comprise après l'heure de coucher
            if (horaire_exception_debut_moment.isAfter(this_.heure_coucher_soleil_moment)
            && horaire_exception_fin_moment.isAfter(this_.heure_coucher_soleil_moment)) {

              if (is_exception_fin_journee) {
                this_.resetTrancheHoraireExclusion(i_voie);
                this_.exclure_horaire[i_voie].is_error = true;
                continue;
              }

              is_exception_fin_journee = true;

              if (horaire_exception_fin_moment.isBefore(Moment("23:55", "HH:mm"))) {
                tab_horaires_exclusion.push([horaire_exception_fin_moment.format("HH:mm").valueOf(), "23:55"]);
              }

              tab_horaires_exclusion.push([this_.heure_coucher_soleil_moment.format("HH:mm").valueOf(), horaire_exception_debut_moment.format("HH:mm").valueOf()]);

            }

            // Exception à cheval sur l'heure de coucher
            if (horaire_exception_debut_moment.isBefore(this_.heure_coucher_soleil_moment)
            && horaire_exception_fin_moment.isAfter(this_.heure_coucher_soleil_moment)) {

              if (is_exception_fin_journee) {
                this_.resetTrancheHoraireExclusion(i_voie);
                this_.exclure_horaire[i_voie].is_error = true;
                continue;
              }

              is_exception_fin_journee = true;

              tab_horaires_exclusion.push([horaire_exception_fin_moment.format("HH:mm").valueOf(), "23:55"]);

            }

          } // For this_.zone.voies[i_voie].interval_exclusion_allumage

          // Pas d'exclusion le matin ou le soir ? On réaffiche les horaires crépusculaire
          if (!is_exception_debut_journee) {
            tab_horaires_exclusion.push(["00:00", this_.heure_levee_soleil_moment.format("HH:mm").valueOf()]);
          }

          // De même pour le soir
          if (!is_exception_fin_journee) {
            tab_horaires_exclusion.push([this_.heure_coucher_soleil_moment.format("HH:mm").valueOf(), "23:55"]);
          }

          if (tab_horaires_exclusion.length) {
            for (var i_exclusion = 0, length_exclusion = tab_horaires_exclusion.length; i_exclusion < length_exclusion; i_exclusion++) {
              schedule.push({
                start: tab_horaires_exclusion[i_exclusion][0],
                end: tab_horaires_exclusion[i_exclusion][1],
                text:'',
                i_v: i_voie,
                i_h: i_horaire,
              });
            }
          }

        } else {
          // Non crépusculaire

          for (var i_horaire = 0, length_horaire = this_.zone.voies[i_voie].interval_horaire_allumage.length; i_horaire < length_horaire; i_horaire++){
            let horaire = this_.zone.voies[i_voie].interval_horaire_allumage[i_horaire];
            schedule.push({
              start: horaire.debut,
              end: horaire.fin,
              text:'',
              i_v: i_voie,
              i_h: i_horaire,
            });
          }

        }

        jQuery("#schedule_" + i_voie).empty();

        this_.zone["schedule_" + i_voie] = jQuery("#schedule_" + i_voie).timeSchedule({
          startTime: "00:00", // schedule start time(HH:ii)
          endTime: "23:55",   // schedule end time(HH:ii)
          widthTime: 60 * 5,  // cell timestamp example 10 minutes
          timeBorder: 0,
          timeLineY: 60,       // height(px)
          widthTimeX: 5,
          verticalScrollbar: 20,   // scrollbar (px)
          timeLineBorder: 0,   // border(top and bottom)
          isDraggable: is_crepusculaire,
          rows : {
            '1' : {
              schedule: schedule
            }
          },
          change: function(node,data){

            var debut = Moment.utc(Moment.duration(data.start, 'seconds').asMilliseconds()).format('HH:mm');
            var fin = Moment.utc(Moment.duration(data.end, 'seconds').asMilliseconds()).format('HH:mm');

            // 86100 = 00:00
            if (fin == "00:00" || data.end > 86100) {
              fin = "23:55";
              this_.zone.voies[data.i_v].interval_horaire_allumage[data.i_h].fin = "23:55";
              this_.initCalendar(data.i_v);
            }

            this_.remove_horaire[data.i_v].debut = debut;
            this_.remove_horaire[data.i_v].fin = fin;

            if (this_.zone.voies[data.i_v].interval_horaire_allumage[data.i_h].debut == debut
              && this_.zone.voies[data.i_v].interval_horaire_allumage[data.i_h].fin == fin) return;

              this_.zone.voies[data.i_v].interval_horaire_allumage[data.i_h].debut = debut;
              this_.zone.voies[data.i_v].interval_horaire_allumage[data.i_h].fin = fin;

              this_.is_modification_zone_en_cours = true;
              this_.voies_en_cours_modification.add(data.i_v);

              this_.$forceUpdate();

            },

            init_data: function(node,data){
            },

            click: function(node, data){

              var debut = Moment.utc(Moment.duration(data.start, 'seconds').asMilliseconds()).format('HH:mm');
              var fin = Moment.utc(Moment.duration(data.end, 'seconds').asMilliseconds()).format('HH:mm');

              if (fin == "00:00") {
                fin = "23:55";
              }

              this_.modal_voie_en_cours = data.i_v;

              this_.remove_horaire[data.i_v].is_show = true;
              this_.remove_horaire[data.i_v].i_z = data.i_z;
              this_.remove_horaire[data.i_v].i_v = data.i_v;
              this_.remove_horaire[data.i_v].i_h = data.i_h;

              this_.remove_horaire[data.i_v].debut = debut;
              this_.remove_horaire[data.i_v].fin = fin;

              this_.modal.i_v = data.i_v;

              // Voie crépusculaire ?
              if (this_.zone.voies[data.i_v].is_crepusculaire) {
                Alertify.modalCrepusculaire(document.getElementById("modal-crepusculaire")).setting('title', "Supprimer une tranche horaire");
              } else {
                Alertify.modalDelete(document.getElementById("modal-delete")).setting('title', "Supprimer une tranche horaire");
              }

              this_.$forceUpdate();

            },

            append: function(node,data){

            },

            time_click: function(time,data){

            },
          });

        }, 300);

      },

      /*
      * Suppression de la zone
      */
      removeZone: function() {

        Alertify.modalRemoveZone().close();

        if (this.zone && this.zone.overlay) this.zone.overlay.setMap(null);

        Axios.delete(func.url_backend + '/api/nodlight/sites/' + this.user.id_site + '/zones/' + this.zone.id_zone).then((response) => {
          if (response.data.ok) {
            this.$popup({ message: 'Zone supprimée !' });
            this.getZones();
            this.toggleNavbar(false);
          }
        }).catch( (error) => {
          console.log(error);
        });

      },

      /*
      * Toggle la toolbar
      */
      toggleNavbar: function(is_ouverture){

        var sidebar = jQuery(document.querySelector("#mainMenu"));
        var sidebar2 = jQuery(document.querySelector("#closeToggleMenu"));
        var chevron = jQuery(document.querySelector("#closeToggleMenu i"));

        // Rotation du chevron lors de l'ouverture / fermeture
        function rotateChevron(angle) {
          chevron.css({
            transform: 'rotate(' + angle + 'deg)'
          });
        }

        switch (is_ouverture) {

          // Comportement normal (toggle)
          case undefined:

          var is_bottom = sidebar.hasClass("sidebar-vertical-bottom");

          if (is_bottom) {
            sidebar.stop().removeClass('sidebar-vertical-bottom');
          } else {
            sidebar.stop().addClass('sidebar-vertical-bottom');
          }

          ;break;

          // Forcage ouverture
          case true:

          sidebar.stop().removeClass('sidebar-vertical-bottom');

          break;

          // Forcage ouverture
          case false:

          sidebar.stop().addClass('sidebar-vertical-bottom');

          break;

        }

      },

      /*
      * Centre la carte vers un point de coordonnées.
      */
      centreGoogleMapTo: function(obj, type) {
        try {
          if (!obj) return;

          if (type) {
            switch (type) {
              case "rectangle": var center = new google.maps.LatLng(obj.coords.bounds.north - 0.006, obj.coords.bounds.west); break;
              case "circle": var center = new google.maps.LatLng(obj.coords.center.lat - 0.006, obj.coords.center.lng); break;
              case "polygon": var center = new google.maps.LatLng(obj.coords[0].lat - 0.006, obj.coords[0].lng); break;
            }
          } else {
            var center = new google.maps.LatLng(obj.lat - 0.006, obj.lng);
          }

          this.map.panTo(center);
        } catch (e) {
            // Pas de connexion internet

        }
      },

      /*
      * Initialise la carte
      */
      initGoogleMap: function() {
        try {

          if (this.map) return;

          // Initialisation de la carte
          this.map = new google.maps.Map(document.getElementById('carte-google'), {
            zoom: func.google.map.zoom,
            center: func.google.map.center,
            styles: func.google.map.style,
            mapTypeControl: false,
            streetViewControl: false,
            disableDoubleClickZoom: true,
            mapTypeId: 'roadmap'
          });

        } catch(e) {
          // Pas de connexion internet ?
        }

      }

    }

  }

  </script>



// WEBPACK FOOTER //
// src/components/Carte.vue